<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import Swal from "sweetalert2";
import { cloneDeep } from "lodash";
import { required } from "vuelidate/lib/validators";
import groupBy from "lodash/groupBy";
import UploadPopover from "@/components/widgets/upload-popover.vue";
import PrintOptions from "@/components/modals/print-options.vue";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
import Multiselect from "vue-multiselect";
import Switches from "vue-switches";
import AttachmentModal from "@/components/modals/attachment-modal.vue";
import RatingScale from "@/components/modals/rating-scale.vue";
import RawData from "@/components/widgets/raw-data.vue";

export default {
  page: {
    title: "Actual Targets/Deliverables",
  },
  components: {
    Layout,
    PageHeader,
    UploadPopover,
    PrintOptions,
    MaskedInput,
    Multiselect,
    Switches,
    AttachmentModal,
    RatingScale,
    RawData,
  },
  data() {
    return {
      title: `My Actual ${this.$store.state.data.selectedCampus.isExternal
        ? "Deliverables"
        : "Targets"
        }`,
      submitted: false,
      items: [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: `My Actual ${this.$store.state.data.selectedCampus.isExternal
            ? "Deliverables"
            : "Targets"
            }`,
          active: true,
        },
      ],
      titleList: this.$store.state.data.selectedCampus.isExternal
        ? "Deliverable"
        : "Target",
      tableData: [],
      modalTitle: "",
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      filter: "",
      filterOn: [],
      sortBy: "cluster",
      sortDesc: false,
      currencyMask: createNumberMask({
        prefix: "",
        allowDecimal: true,
        includeThousandsSeparator: false,
      }),
      movFields: [
        {
          key: "mode",
          label: "Mode",
          sortable: true,
        },
        {
          key: "description",
          label: "Description",
          sortable: true,
        },
        {
          key: "attachments",
          label: "Attachments",
        },
        {
          key: "actions",
          label: "Actions",
          thStyle: { width: "90px" },
        },
      ],
      form: {
        id: 0,
        q1: 0,
        q1Remarks: "",
        q2: 0,
        q2Remarks: "",
        q3: 0,
        q3Remarks: "",
        q4: 0,
        q4Remarks: "",
        catchUpPlans: "",
        finalRemarks: "",
        scoreQuality: "",
        scoreEfficiency: "",
        scoreTimeliness: "",
        actualAccomplishment: "",
        annualTarget: "",
      },
      mov: {
        id: 0,
        targetId: 0,
        mode: "",
        description: "",
      },
      interveningTaskForm: {
        deliveryUnitId: null,
        cycle: null,
        remarks: "",
        q1: "0",
        q2: "0",
        q3: "0",
        q4: "0",
        cascadedTarget: "0",
        isPercentage: false,
      },
      indexSelected: -1,
      tableBusy: false,
      uploadOptions: {
        type: "Target",
        placement: "left",
        folder: "Planning",
      },
      row: {},
      attWActions: false,
      uploadTitle: null,
      selectedTarget: "Actual",
      showUpdate: false,
      slideNo: 1,
      carouselModel: 0,
      rating: [],
      selectedTargetData: null,
      q1RemarksLines: 1,
      q2RemarksLines: 1,
      q3RemarksLines: 1,
      q4RemarksLines: 1,
      selectedMOV: null,
      measurementData: [],
      ratingBusy: false,
      movData: [],
      qualityOptions: [],
      efficiencyOptions: [],
      timelinessOptions: [],
      returnRemarks: [],
      returnRemarksTitle: "",
      alreadySaved: false,
      alreadySavedQ1: false,
      alreadySavedQ2: false,
      alreadySavedQ3: false,
      alreadySavedQ4: false,
      attachmentLoading: false,
      attachmentQuarter: "",
      ratingLoading: false,
      tabSelect: "Strategic Priority",
      tabOptions: [
        "Strategic Priority",
        "Core Functions",
        "Mandatory Support Function",
      ],
      tabIndex: 0,
      accomplishmentDeadline: null,
      returnDeadline: null,
      notificationData: [],
      selectedDU: this.$store.state.data.selectedDU.id,
    };
  },
  validations: {
    form: {
      q1: { required },
      q2: { required },
      q3: { required },
      q4: { required },
    },
    rating: {
      description: { required },
    },
    mov: {
      mode: { required },
      description: { required },
    },
    interveningTaskForm: {
      remarks: { required },
      q1: { required },
      q2: { required },
      q3: { required },
      q4: { required },
      cascadedTarget: { required },
    },
  },
  computed: {
    grouped() {
      var array = [];
      var x = groupBy(this.filteredData, "mainTarget.indicatorItemId");
      for (const key in x) {
        array.push({
          indicatorItemId: key,
          indicatorItemName:
            x[key][0].mainTarget.indicatorItem.indicatorItemName,
          details: x[key],
          showTargets: false,
        });
      }
      return array;
    },
    filteredData() {
      let data = this.tableData;
      data = data.filter((item) => {
        if (this.tabSelect == "Strategic Priority")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (this.tabSelect == "Core Functions")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("CORE");
        else if (this.tabSelect == "Mandatory Support Function")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("MANDATORY");
      });
      if (this.filter.trim() != "" && this.filter) {
        data = data.filter((item) => {
          return item.searchKey
            .toUpperCase()
            .includes(this.filter.toUpperCase());
        });
      }
      return data;
    },
    paginatedData() {
      let data = this.grouped;
      var total = this.currentPage * this.perPage;
      data = data.slice(total - this.perPage, total);
      return data;
    },
    rows() {
      return this.grouped.length;
    },
  },
  created() {
    this.totalRows = this.items.length;
    this.changeCycle(this.$store.state.data.cycle);
  },
  methods: {
    checkTab(type) {
      let data = this.tableData;
      data = data.filter((item) => {
        if (type == "Strategic Priority")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (type == "Core Functions")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("CORE");
        else if (type == "Mandatory Support Function")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("MANDATORY");
      });
      return data.length > 0 ? true : false;
    },
    setTabSelect() {
      this.tabIndex = 0;
      this.tabSelect = this.checkTab("Strategic Priority")
        ? "Strategic Priority"
        : this.checkTab("Core Functions")
          ? "Core Functions"
          : "Mandatory Support Function";
    },
    changeCycle(cycle) {
      this.getMyActualTargets(cycle, this.$store.state.data.selectedDU.id);
    },
    async getNotificationData(cycle, campusId, deliveryUnitId) {
      await this.$store
        .dispatch("dashboard/GetMenuCounts", {
          cycle,
          campusId,
          deliveryUnitId,
        })
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          // this.notificationData = res.data.targetIds;
          this.notificationData = [];
        });
    },
    typeNotifCount(type) {
      let data = this.tableData;
      data = data.filter((item) => {
        if (type == "Strategic Priority")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("STRATEGIC");
        else if (type == "Core Functions")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("CORE");
        else if (type == "Mandatory Support Function")
          return item.mainTarget.indicatorItem.indicatorItemClassification.classification
            .toUpperCase()
            .includes("MANDATORY");
        else return item;
      });
      var count = 0;
      data.forEach((target) => {
        if (target.notification) count++;
      });
      return count;
    },
    kpiNotifCount(targetArray) {
      var count = 0;
      targetArray.forEach((target) => {
        if (target.notification) count++;
      });
      return count;
    },
    async getMyActualTargets(cycle, deliveryUnitId) {
      this.selectedDu = deliveryUnitId;
      this.tableBusy = true;
      await this.getNotificationData(
        this.$store.state.data.cycle,
        this.$store.state.data.selectedCampus.id,
        this.$store.state.data.selectedDU.id
      );
      await this.$store
        .dispatch("target/GetMyTarget", { cycle, deliveryUnitId })
        .then((res) => {
          res.data.forEach((item) => {
            item.addDocu = false;
            item.showDetails = false;
            item.departmentList = [];
            item.assignedDepartments = [];
            item.detailVisible = true;
            item.attachmentLoading = false;
            item.fileSearch = "";
            item.attachments = [];
            item.showAttachments = false;
            item.showMOV = false;
            item.mov = [];
            item.searchMOV = "";
            item.movLoading = false;
            item.searchKey = `${item.mainTarget.indicatorItem.indicatorItemName} ${item.remarks}`;
            item.notification =
              this.notificationData.filter((notifTargetId) => {
                return notifTargetId == item.id;
              }).length > 0
                ? true
                : false;
          });
          this.tableData = res.data;
          this.setTabSelect();
          this.tableBusy = false;
        })
        .catch((err) => {
          console.log(err);
          this.tableBusy = false;
          this.showToast("Something went wrong!", "error");
        });
      await this.$store
        .dispatch("submissiondeadline/GetSubmissionDeadline", cycle)
        .then((res) => {
          this.accomplishmentDeadline = res.data.find(
            (x) =>
              x.referenceType.toLowerCase() === "accomplishment - du" &&
              x.type.toLowerCase() === "planning" &&
              x.referenceId === this.$store.state.data.selectedDU.id
          );
          if (!this.accomplishmentDeadline) {
            this.accomplishmentDeadline = res.data.find(
              (x) =>
                x.referenceType.toLowerCase() === "accomplishment" &&
                x.type.toLowerCase() === "planning" &&
                x.referenceId === 0
            );
          }
          this.returnDeadline = res.data.find(
            (x) =>
              x.referenceType.toLowerCase() === "returned - du" &&
              x.type.toLowerCase() === "planning" &&
              x.referenceId === this.$store.state.data.selectedDU.id
          );
          if (!this.returnDeadline) {
            this.returnDeadline = res.data.find(
              (x) =>
                x.referenceType.toLowerCase() === "returned" &&
                x.type.toLowerCase() === "planning" &&
                x.referenceId === 0
            );
          }
        });
    },
    async getDepartmentsByTarget(row) {
      row.showDetails = !row.showDetails;
      this.$forceUpdate();
      if (row.showDetails) {
        await this.getDepartments(row);
        await this.getAssignedDepartments(row);
      }
    },
    async getDepartments(row) {
      row.departmentList = [];
      this.$store
        .dispatch("planningtarget/GetDepartmentsByTarget", row.planningTargetId)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          row.departmentList = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    async getAssignedDepartments(row) {
      row.assignedDepartments = [];
      this.$store
        .dispatch(
          "planningtargetdepartment/GetPlanningTargetDepartment",
          row.planningTargetId
        )
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          row.assignedDepartments = res.data;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
    },
    onFiltered(filteredItems) {
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    onAddInterveningTask() {
      this.submitted = true;
      this.$v.interveningTaskForm.$touch();
      if (this.$v.interveningTaskForm.$invalid) {
        return;
      }
      this.tableBusy = true;
      this.$store
        .dispatch("target/AddInterveningTask", this.interveningTaskForm)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          res.data.addDocu = false;
          res.data.showDetails = false;
          res.data.detailVisible = true;
          res.data.attachmentLoading = false;
          res.data.fileSearch = "";
          res.data.attachments = [];
          res.data.showAttachments = false;
          res.data.showMOV = false;
          res.data.mov = [];
          res.data.searchMOV = "";
          res.data.movLoading = false;
          res.data.searchKey = `${res.data.mainTarget.indicatorItem.indicatorItemName} ${res.data.remarks}`;
          res.data.notification =
            this.notificationData.filter((notifTargetId) => {
              return notifTargetId == res.data.id;
            }).length > 0
              ? true
              : false;
          this.tableData.push(res.data);
          this.tableBusy = false;
          this.submitted = false;
          this.$bvModal.hide("modal-interveningTask");
          this.showToast(
            "Successfully added Intervening Task to Core Functions!",
            "success"
          );
        })
        .catch((err) => {
          return this.showToast("Something went wrong!", "error");
        });
    },
    addInterveningTask() {
      this.submitted = false;
      this.interveningTaskForm = {
        deliveryUnitId: this.$store.state.data.selectedDU.id,
        cycle: this.$store.state.data.cycle,
        remarks: "",
        q1: "0",
        q2: "0",
        q3: "0",
        q4: "0",
        cascadedTarget: "0",
        isPercentage: false,
      };
      this.$bvModal.show("modal-interveningTask");
    },
    deleteInterveningTask(id) {
      Swal.fire({
        title: "Are you sure?",
        text: "You are about to delete this target.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, delete it!",
      }).then(async (result) => {
        if (result.value) {
          this.$store
            .dispatch("target/DeleteTarget", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.tableData.findIndex((item) => item.id == id);
              this.tableData.splice(index, 1);
              this.showToast("Successfully deleted!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    async onCreate(postAction) {
      this.submitted = true;
      this.$v.form.$touch();
      if (this.$v.form.$invalid) {
        return;
      }
      let returnId = 0;
      if (this.form.id > 0) {
        await this.$store
          .dispatch("actual/UpdateActual", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            this.selectedTargetData.actual = [this.form];
            this.tableData.splice(
              this.indexSelected,
              1,
              this.selectedTargetData
            );
            returnId = this.form.id;
            this.alreadySavedQ1 =
              (this.form.q1 == 0 || this.form.q1 == "0") &&
                this.form.q1Remarks == ""
                ? false
                : true;
            this.alreadySavedQ2 =
              (this.form.q2 == 0 || this.form.q2 == "0") &&
                this.form.q2Remarks == ""
                ? false
                : true;
            this.alreadySavedQ3 =
              (this.form.q3 == 0 || this.form.q3 == "0") &&
                this.form.q3Remarks == ""
                ? false
                : true;
            this.alreadySavedQ4 =
              (this.form.q4 == 0 || this.form.q4 == "0") &&
                this.form.q4Remarks == ""
                ? false
                : true;
            if (!postAction) {
              this.showToast("Successfully updated!", "success");
            }
          })
          .catch((err) => {
            if (!postAction) {
              return this.showToast("Something went wrong!", "error");
            }
          });
      } else {
        await this.$store
          .dispatch("actual/CreateActual", this.form)
          .then((res) => {
            if (res.data.error) {
              return this.showToast(res.data.errorMessage, "error");
            }
            returnId = res.data.id;
            this.form.id = res.data.id;
            this.form.status = "Pending";
            this.selectedTargetData.actual = [this.form];
            this.tableData.splice(
              this.indexSelected,
              1,
              this.selectedTargetData
            );
            this.alreadySavedQ1 =
              (this.form.q1 == 0 || this.form.q1 == "0") &&
                this.form.q1Remarks == ""
                ? false
                : true;
            this.alreadySavedQ2 =
              (this.form.q2 == 0 || this.form.q2 == "0") &&
                this.form.q2Remarks == ""
                ? false
                : true;
            this.alreadySavedQ3 =
              (this.form.q3 == 0 || this.form.q3 == "0") &&
                this.form.q3Remarks == ""
                ? false
                : true;
            this.alreadySavedQ4 =
              (this.form.q4 == 0 || this.form.q4 == "0") &&
                this.form.q4Remarks == ""
                ? false
                : true;
            this.$forceUpdate();
            if (!postAction) {
              this.showToast("Successfully updated!", "success");
            }
          })
          .catch((err) => {
            if (!postAction) {
              return this.showToast("Something went wrong!", "error");
            }
          });
      }
      this.$forceUpdate();
      this.submitted = false;
      return returnId;
    },
    getAnnualTarget(row, isPercentage) {
      if (isPercentage) {
        if (row.q4 > 0) {
          return row.q4;
        }
        if (row.q3 > 0) {
          return row.q3;
        }
        if (row.q2 > 0) {
          return row.q2;
        }
        if (row.q1 > 0) {
          return row.q1;
        }
        return 0;
      } else {
        return parseFloat(row.q1) + parseFloat(row.q2) + parseFloat(row.q3) + parseFloat(row.q4);
      }
    },
    async setActualValue(props) {
      if (props.ratingScaleStatus != "POSTED") {
        Swal.fire({
          title: "Cannot proceed.",
          text: "Post performance rubric to proceed.",
          icon: "error",
          confirmButtonColor: "#7367f0",
          confirmButtonText: "Close",
        });
        return;
      }
      props.showAttachments = false;
      this.ratingLoading = true;
      this.modalTitle = "Update Actual Output";
      this.$bvModal.show("modal-actual");
      await this.getQETRating(props.id);
      await this.getMOV(props.id);
      this.submitted = false;
      this.alreadySaved = false;
      this.alreadySavedQ1 = false;
      this.alreadySavedQ2 = false;
      this.alreadySavedQ3 = false;
      this.alreadySavedQ4 = false;
      this.indexSelected = this.tableData.findIndex(
        (item) => item.id == props.id
      );
      this.selectedTargetData = cloneDeep(props);
      this.row = {
        q1: cloneDeep(props.q1),
        q2: cloneDeep(props.q2),
        q3: cloneDeep(props.q3),
        q4: cloneDeep(props.q4),
      };
      if (props.actual.length > 0) {
        this.alreadySaved = props.actual[0].status == "POSTED" ? true : false;
        this.alreadySavedQ1 =
          props.actual[0].q1 == 0 && props.actual[0].q1Remarks == ""
            ? false
            : true;
        this.alreadySavedQ2 =
          props.actual[0].q2 == 0 && props.actual[0].q2Remarks == ""
            ? false
            : true;
        this.alreadySavedQ3 =
          props.actual[0].q3 == 0 && props.actual[0].q3Remarks == ""
            ? false
            : true;
        this.alreadySavedQ4 =
          props.actual[0].q4 == 0 && props.actual[0].q4Remarks == ""
            ? false
            : true;
        this.form = cloneDeep(props.actual[0]);
        this.form.q1 = props.actual[0].q1.toString();
        this.q1RemarksLine = props.actual[0].q1Remarks
          .toString()
          .split(/\r\n|\r|\n/).length;
        this.form.q2 = props.actual[0].q2.toString();
        this.q2RemarksLine = props.actual[0].q2Remarks
          .toString()
          .split(/\r\n|\r|\n/).length;
        this.form.q3 = props.actual[0].q3.toString();
        this.q3RemarksLine = props.actual[0].q3Remarks
          .toString()
          .split(/\r\n|\r|\n/).length;
        this.form.q4 = props.actual[0].q4.toString();
        this.q4RemarksLine = props.actual[0].q4Remarks
          .toString()
          .split(/\r\n|\r|\n/).length;
        this.form.scoreQuality =
          this.qualityOptions.length > 0 ? props.scoreQuality : "";
        this.form.scoreEfficiency =
          this.efficiencyOptions.length > 0 ? props.scoreEfficiency : "";
        this.form.scoreTimeliness =
          this.timelinessOptions.length > 0 ? props.scoreTimeliness : "";
      } else {
        this.form = {
          id: 0,
          q1: "0",
          q1PostedBy: null,
          q1Remarks: "",
          q2: "0",
          q2PostedBy: null,
          q2Remarks: "",
          q3: "0",
          q3PostedBy: null,
          q3Remarks: "",
          q4: "0",
          q4PostedBy: null,
          q4Remarks: "",
          catchUpPlans: "",
          finalRemarks: "",
          scoreQuality: "",
          scoreEfficiency: "",
          scoreTimeliness: "",
          targetId: props.id,
        };
        this.q1RemarksLines = 1;
        this.q2RemarksLines = 1;
        this.q3RemarksLines = 1;
        this.q4RemarksLines = 1;
      }
      this.form.actualAccomplishment =
        props.actualAccomplishment == null
          ? props.actual.length > 0
            ? this.getAnnualTarget(
              props.actual[0],
              props.mainTarget.isPercentage
            ).toString()
            : "0"
          : props.actualAccomplishment.toString();
      this.form.annualTarget =
        props.annualTarget == null
          ? this.getAnnualTarget(
            props,
            props.mainTarget.isPercentage
          ).toString()
          : props.annualTarget.toString();
      setTimeout(() => {
        this.ratingLoading = false;
      }, 100);
      this.$nextTick(() => {
        setTimeout(() => {
          this.autoGrowTemplate(this.$refs.q1Remarks, 15);
          this.autoGrowTemplate(this.$refs.q2Remarks, 15);
          this.autoGrowTemplate(this.$refs.q3Remarks, 15);
          this.autoGrowTemplate(this.$refs.q4Remarks, 15);
          this.autoGrowTemplate(this.$refs.catchupPlans, 15);
          this.autoGrowTemplate(this.$refs.finalRemarks, 15);
        }, 100);
      });
    },
    async getMOV(id) {
      this.movData = [];
      await this.$store.dispatch("mov/GetMOVByTarget", id).then(async (res) => {
        if (res.data.error) {
          return this.showToast(res.data.errorMessage, "error");
        }
        res.data.forEach((item) => {
          item.attachments = [];
          item.addDocu = false;
          item.uploadOptions = null;
        });
        this.movData = res.data;
        this.movData.push({
          id: `others-${id}`,
          targetId: id,
          target: null,
          mode: "OTHERS",
          description: "",
          attachments: [],
          addDocu: false,
          uploadOptions: null,
        });
        this.movData.push({
          id: `catchup-${id}`,
          targetId: id,
          target: null,
          mode: "CATCHUP PLANS",
          description: "",
          attachments: [],
          addDocu: false,
          uploadOptions: null,
        });
      });
    },
    async getQETRating(id) {
      await this.$store
        .dispatch("ratingscale/GetRatingScale", id)
        .then((res) => {
          if (res.data.length > 0) {
            this.qualityOptions = res.data.filter((item) => {
              return item.type == "EFFECTIVENESS/QUALITY";
            });
            this.efficiencyOptions = res.data.filter((item) => {
              return item.type == "EFFICIENCY";
            });
            this.timelinessOptions = res.data.filter((item) => {
              return item.type == "TIMELINESS";
            });
          } else {
            this.qualityOptions = [
              { rating: 0, description: "", type: "EFFECTIVENESS/QUALITY" },
              { rating: 1, description: "", type: "EFFECTIVENESS/QUALITY" },
              { rating: 2, description: "", type: "EFFECTIVENESS/QUALITY" },
              { rating: 3, description: "", type: "EFFECTIVENESS/QUALITY" },
              { rating: 4, description: "", type: "EFFECTIVENESS/QUALITY" },
              { rating: 5, description: "", type: "EFFECTIVENESS/QUALITY" },
            ];
            this.efficiencyOptions = [
              { rating: 0, description: "", type: "EFFICIENCY" },
              { rating: 1, description: "", type: "EFFICIENCY" },
              { rating: 2, description: "", type: "EFFICIENCY" },
              { rating: 3, description: "", type: "EFFICIENCY" },
              { rating: 4, description: "", type: "EFFICIENCY" },
              { rating: 5, description: "", type: "EFFICIENCY" },
            ];
            this.timelinessOptions = [
              { rating: 0, description: "", type: "TIMELINESS" },
              { rating: 1, description: "", type: "TIMELINESS" },
              { rating: 2, description: "", type: "TIMELINESS" },
              { rating: 3, description: "", type: "TIMELINESS" },
              { rating: 4, description: "", type: "TIMELINESS" },
              { rating: 5, description: "", type: "TIMELINESS" },
            ];
          }
          this.$forceUpdate();
        });
    },
    onQETSelect(option) {
      if (option.type == "EFFECTIVENESS/QUALITY") {
        this.form.scoreQuality = option.rating;
      }
      if (option.type == "EFFICIENCY") {
        this.form.scoreEfficiency = option.rating;
      }
      if (option.type == "TIMELINESS") {
        this.form.scoreTimeliness = option.rating;
      }
      this.$forceUpdate();
    },
    autoGrowTemplate(element, size) {
      if (element) {
        element.style.height = `${size}px`;
        element.style.height = `${element.scrollHeight}px`;
      }
    },
    setMeasurement(row) {
      this.$refs.RatingScale.setMeasurement(row, "du");
      this.indexSelected = this.tableData.findIndex(
        (item) => item.id == row.id
      );
      this.selectedTargetData = cloneDeep(row);
    },
    saveRatingStatus(status) {
      this.tableData[this.indexSelected].ratingScaleStatus = status;
      this.$forceUpdate();
    },
    async getAttachments(row) {
      row.showAttachments = !row.showAttachments;
      if (!row.showAttachments) return;
      row.attachmentLoading = true;
      row.attachments = [];
      row.mov = [];
      await this.getMOV(row.id);
      row.mov = this.movData;
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: this.uploadOptions.type,
        })
        .then((res) => {
          row.attachments = row.attachments.concat(res.data);
        })
        .catch(() => {
          this.showToast("Something went wrong! - getting documents", "error");
        });
      await this.movData.forEach((item) => {
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 1 Files: ${item.mode}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 1 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 1 Files: ${item.id}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 1 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 2 Files: ${item.mode}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 2 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 2 Files: ${item.id}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 2 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 3 Files: ${item.mode}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 3 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 3 Files: ${item.id}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 3 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 4 Files: ${item.mode}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 4 files",
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: row.id,
            type: `Quarter 4 Files: ${item.id}`,
          })
          .then((res) => {
            row.attachments = row.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              "Something went wrong! - getting quarter 4 files",
              "error"
            );
          });
      });
      await this.$store
        .dispatch("filemanager/GetFiles", {
          id: row.id,
          type: "Catchup Plan Attachment",
        })
        .then((res) => {
          row.attachments = row.attachments.concat(res.data);
        })
        .catch(() => {
          this.showToast(
            "Something went wrong! - getting catchup plan files",
            "error"
          );
        });
      await setTimeout(() => {
        row.attachmentLoading = false;
      }, 500);
    },
    openDocument(x) {
      this.readFile(x.id);
    },
    removeFile(id, parentId) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let index = this.tableData.findIndex(
                (item) => item.id == parentId
              );
              let yIndex = this.tableData[index].attachments.findIndex(
                (item) => item.id == id
              );
              this.tableData[index].attachments.splice(yIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be remove!", "error");
            });
        }
      });
    },
    removeQuarterFile(id, parentId) {
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        cancelButtonColor: "#5c636a",
        confirmButtonText: "Yes, remove it!",
      }).then((result) => {
        if (result.value) {
          this.$store
            .dispatch("filemanager/DeleteFile", id)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              let movIndex = this.movData.findIndex(
                (item) => item.id == parentId
              );
              let fileIndex = this.movData[movIndex].attachments.findIndex(
                (item) => item.id == id
              );
              this.movData[movIndex].attachments.splice(fileIndex, 1);
              this.showToast("Successfully removed!", "success");
            })
            .catch(() => {
              this.showToast("Cannot be remove!", "error");
            });
        }
      });
    },
    uploadedDocument(response, id, type, movId) {
      if (type == "Target") {
        let index = this.tableData.findIndex((item) => item.id == id);
        this.tableData[index].attachments.push(response);
      } else {
        let index = this.movData.findIndex((item) => item.id == movId);
        this.movData[index].attachments.push(response);
      }
    },
    searchDocu(row, type) {
      let data = type
        ? row.attachments.filter((item) => {
          return item.type == type;
        })
        : row.attachments;
      if (row.fileSearch.trim() != "" && row.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(row.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    searchQuarterDocu(row, modeType, idType) {
      //tungod sayop ang first type sa docu
      let modeDocu = row.attachments.filter((item) => {
        return item.type == modeType;
      });
      let idDocu = row.attachments.filter((item) => {
        return item.type == idType;
      });
      let data = modeDocu.concat(idDocu);
      if (row.fileSearch.trim() != "" && row.fileSearch) {
        data = data.filter((item) => {
          return item.description
            .toUpperCase()
            .includes(row.fileSearch.toUpperCase());
        });
      }
      return data;
    },
    filterDocuByType(attachments, modeType, idType) {
      //tungod sayop ang first type sa docu
      let modeDocu = attachments.filter((item) => {
        return item.type == modeType;
      });
      let idDocu = attachments.filter((item) => {
        return item.type == idType;
      });
      let data = modeDocu.concat(idDocu);
      return data;
    },
    autoGrow(element, size) {
      element.target.style.height = `${size}px`;
      element.target.style.height = `${element.target.scrollHeight}px`;
    },
    async postQuarter(quarter) {
      Swal.fire({
        title: "Are you sure?",
        text: "You want to post this?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, post it!",
      }).then(async (result) => {
        if (result.value) {
          await this.updateTarget();
          const resultId = await this.onCreate(true);
          await this.$store
            .dispatch("actual/PostActualByQuarter", {
              id: resultId,
              quarter: quarter,
            })
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.form[`q${quarter}PostedBy`] = "POSTED";
              this.selectedTargetData.actual = [this.form];
              if (!this.checkReturnStatus(this.selectedTargetData)) {
                this.selectedTargetData.notification = false;
              }
              this.tableData.splice(
                this.indexSelected,
                1,
                this.selectedTargetData
              );
              this.showToast("Successfully posted!", "success");
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
        }
      });
    },
    async viewQuarterAttachment(quarter, status) {
      if (!status) {
        this.attWActions = true;
      } else {
        this.attWActions = false;
      }
      this.attachmentLoading = true;
      this.modalTitle = `Quarter ${quarter} Attachment`;
      this.attachmentQuarter = quarter;
      this.$bvModal.show("modal-quarterAttachments");
      await this.movData.forEach((item) => {
        item.attachments = [];
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: this.selectedTargetData.id,
            type: `Quarter ${quarter} Files: ${item.mode}`,
          })
          .then((res) => {
            item.attachments = item.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              `Something went wrong! - getting quarter ${quarter} files.`,
              "error"
            );
          });
        this.$store
          .dispatch("filemanager/GetFiles", {
            id: this.selectedTargetData.id,
            type: `Quarter ${quarter} Files: ${item.id}`,
          })
          .then((res) => {
            item.attachments = item.attachments.concat(res.data);
          })
          .catch(() => {
            this.showToast(
              `Something went wrong! - getting quarter ${quarter} files.`,
              "error"
            );
          });
        item.uploadOptions = {
          type: `Quarter ${quarter} Files: ${item.id}`,
          placement: "left",
          folder: "Planning",
        };
      });
      await setTimeout(() => {
        this.attachmentLoading = false;
      }, 500);
    },
    viewCatchupAttachment(status) {
      if (!status) {
        this.attWActions = true;
      } else {
        this.attWActions = false;
      }
      this.uploadTitle = `Catchup Plan / Justification Attachment`;
      this.$refs.attachmentModal.setUploadOpt({
        type: `Catchup Plan Attachment`,
        placement: "left",
        folder: "Planning",
      });
      this.$refs.attachmentModal.getData(this.form.targetId);
      this.$bvModal.show("upload-attachment-modal");
    },
    viewReturnRemarks(pmeLogs, pmtLogs) {
      pmeLogs = pmeLogs ? pmeLogs : [];
      let logs = pmeLogs.concat(pmtLogs);
      this.returnRemarksTitle = "View Logs";
      this.returnRemarks = logs
        .sort((a, b) => new Date(b.remarksDate) - new Date(a.remarksDate));
      this.returnRemarks.forEach((item) => {
        item.dateWTime = this.formatDateWithTime(new Date(item.remarksDate));
        item.splitted = item.dateWTime.split(" at ");
        item.Employee = item.employee;
        item.Remarks = item.remarks;
      });
      this.$bvModal.show("return-remarks-modal");
    },
    viewQuarterReturnRemarks(props, title) {
      this.returnRemarksTitle = title;
      this.returnRemarks = JSON.parse(props)
        .sort((a, b) => new Date(b.remarksDate || b.RemarksDate) - new Date(a.remarksDate || a.RemarksDate))
      this.returnRemarks.forEach((item) => {
        item.dateWTime = this.formatDateWithTime(
          new Date(title == "View Logs" ? item.remarksDate : item.RemarksDate)
        );
        item.splitted = item.dateWTime.split(" at ");
      });
      this.$bvModal.show("return-remarks-modal");
    },
    closeModal() {
      this.showUpdate = false;
    },
    async updateTarget() {
      this.submitted = true;
      if (
        this.form.annualTarget == "" ||
        this.form.actualAccomplishment == ""
      ) {
        return;
      }
      this.selectedTargetData.annualTarget = this.form.annualTarget;
      this.selectedTargetData.actualAccomplishment =
        this.form.actualAccomplishment;
      var data = this.selectedTargetData;
      this.$store
        .dispatch("target/UpdateTarget", data)
        .then((res) => {
          if (res.data.error) {
            return this.showToast(res.data.errorMessage, "error");
          }
          this.showUpdate = false;
        })
        .catch((err) => {
          this.showToast("Something went wrong!", "error");
        });
      this.submitted = false;
    },
    async saveFinal() {
      this.submitted = true;
      if (
        (this.form.scoreQuality == 0 &&
          this.form.scoreEfficiency == 0 &&
          this.form.scoreTimeliness == 0) ||
        this.form.finalRemarks == "" ||
        this.form.annualTarget == "" ||
        this.form.actualAccomplishment == ""
      ) {
        return;
      }
      Swal.fire({
        title: "Are you sure?",
        text: "Once you save this you can't update it again",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Yes, save it!",
      }).then((result) => {
        if (result.value) {
          this.onCreate(true);
          this.selectedTargetData.scoreQuality = this.form.scoreQuality
            ? this.form.scoreQuality
            : 0;
          this.selectedTargetData.scoreEfficiency = this.form.scoreEfficiency
            ? this.form.scoreEfficiency
            : 0;
          this.selectedTargetData.scoreTimeliness = this.form.scoreTimeliness
            ? this.form.scoreTimeliness
            : 0;
          this.selectedTargetData.annualTarget = this.form.annualTarget;
          this.selectedTargetData.actualAccomplishment =
            this.form.actualAccomplishment;
          if (
            this.selectedTargetData.actual.length > 0 &&
            this.selectedTargetData.actual[0].status != "POSTED"
          ) {
            this.selectedTargetData.evaluationScoreQuality =
              this.selectedTargetData.scoreQuality;
            this.selectedTargetData.evaluationScoreEfficiency =
              this.selectedTargetData.scoreEfficiency;
            this.selectedTargetData.evaluationScoreTimeliness =
              this.selectedTargetData.scoreTimeliness;
          }
          var data = this.selectedTargetData;
          this.$store
            .dispatch("target/UpdateTarget", data)
            .then((res) => {
              if (res.data.error) {
                return this.showToast(res.data.errorMessage, "error");
              }
              this.$store
                .dispatch("actual/PostActual", this.form.id)
                .then((res) => {
                  if (res.data.error) {
                    return this.showToast(res.data.errorMessage, "error");
                  }
                  this.showUpdate = false;
                  data.actual[0].status = "POSTED";
                  if (!this.checkReturnStatus(this.selectedTargetData))
                    data.notification = false;
                  this.tableData.splice(this.indexSelected, 1, data);
                  this.$forceUpdate();
                  this.$bvModal.hide("modal-actual");
                  this.showToast("Successfully saved!", "success");
                });
            })
            .catch((err) => {
              this.showToast("Something went wrong!", "error");
            });
          this.submitted = false;
        }
      });
    },
    checkPostedQuarter() {
      // let withTarget = 0;
      let posted = 0;
      // if (this.row.q1 > 0) {
      //   withTarget++;
      //   if (this.form.q1PostedBy) posted++;
      // }
      // if (this.row.q2 > 0) {
      //   withTarget++;
      //   if (this.form.q2PostedBy) posted++;
      // }
      // if (this.row.q3 > 0) {
      //   withTarget++;
      //   if (this.form.q3PostedBy) posted++;
      // }
      // if (this.row.q4 > 0) {
      //   withTarget++;
      //   if (this.form.q4PostedBy) posted++;
      // }
      // return posted > 0 && posted >= withTarget ? true : false;
      if (this.form.q1PostedBy) posted++;
      if (this.form.q2PostedBy) posted++;
      if (this.form.q3PostedBy) posted++;
      if (this.form.q4PostedBy) posted++;
      return posted > 0 ? true : false;
    },
    checkReturnStatus(selectedTargetData) {
      if (selectedTargetData.actual.length > 0) {
        if (
          selectedTargetData.actual[0].status == "RETURNED" ||
          (!selectedTargetData.actual[0].q1PostedBy &&
            selectedTargetData.actual[0].q1ReturnRemarks != null) ||
          (!selectedTargetData.actual[0].q2PostedBy &&
            selectedTargetData.actual[0].q2ReturnRemarks != null) ||
          (!selectedTargetData.actual[0].q3PostedBy &&
            selectedTargetData.actual[0].q3ReturnRemarks != null) ||
          (!selectedTargetData.actual[0].q4PostedBy &&
            selectedTargetData.actual[0].q4ReturnRemarks != null)
        )
          return true;
        else return false;
      } else return true;
    },
    checkDeadline(returnStatus) {
      if (returnStatus) {
        if (this.setDeadline() && this.setDeadline() < new Date()) return true;
        else return false;
      } else if (
        this.accomplishmentDeadline &&
        new Date(this.accomplishmentDeadline.deadline) < new Date()
      )
        return true;
      else return false;
    },
    setDeadline() {
      if (this.accomplishmentDeadline && this.returnDeadline) {
        if (
          new Date(this.accomplishmentDeadline.deadline) <
          new Date(this.returnDeadline.deadline)
        ) {
          return new Date(this.returnDeadline.deadline);
        } else return new Date(this.accomplishmentDeadline.deadline);
      } else if (this.accomplishmentDeadline && !this.returnDeadline) {
        return new Date(this.accomplishmentDeadline.deadline);
      } else if (!this.accomplishmentDeadline && this.returnDeadline) {
        return new Date(this.returnDeadline.deadline);
      } else return null;
    },
    // Temporary
    checkTemporaryExemption(type, kpi, target) {
      if (
        this.selectedDu == 1224 ||
        this.selectedDu == 1226 ||
        this.selectedDu == 1227 ||
        this.selectedDu == 1228 ||
        this.selectedDu == 1229 ||
        this.selectedDu == 1230
      )
        return true;
      else if (type.toUpperCase().includes("MANDATORY")) return true;
      else if (
        type.toUpperCase().includes("CORE")
        // (kpi.toLowerCase().includes("Utilization Rate - GAA".toLowerCase()) ||
        //   kpi
        //     .toLowerCase()
        //     .includes(
        //       "Utilization Rate - Internally Generated Income".toLowerCase()
        //     ) ||
        //   kpi.toLowerCase().includes("PBB AO25 compliance".toLowerCase()) ||
        //   target.toLowerCase().includes("ISO Certification".toLowerCase()) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "100% Compliance with Internal Quality Findings (if any)".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "100% of Personnel attended/participated in Learning and Development Activities".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "80% of clients rated the services of the office at least above average".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Annual Report submitted to PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Annual Report submitted to appropriate PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes("Annual Report submitted".toLowerCase()) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "OPCR-LIB-TPMS-PPMP proposal for FY 2025 submitted to appropriate PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "OPCR proposal submitted to appropriate PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes("OPCR proposal submitted".toLowerCase()) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Quarterly Accomplishment Report submitted to appropriate  PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Quarterly Accomplishment Report submitted to appropriate PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Quarterly Accomplishment Report submitted to respective PMEs".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Quarterly Accomplishment Report submitted".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Self-rated OPCR evaluation form with supporting documents submitted to appropriate PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes("Self-rated OPCR evaluation form".toLowerCase()) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Rated OPCR FY 2023 with evidences for Review and Evaluation submitted to appropriate PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes(
        //       "Semi-Annual report submitted to appropriate PME Office on time".toLowerCase()
        //     ) ||
        //   target
        //     .toLowerCase()
        //     .includes("Semi-Annual report submitted".toLowerCase()))
      )
        return true;
      else return false;
    },
    validatorFeedback(feedback) {
      if (feedback == "") return "";
      if (feedback == "LSD") return "Lacking supporting documents (LSD)";
      if (feedback == "NTI") return "No Target Indicated (NTI)";
      if (feedback == "NAI") return "No Accomplishment Indicated (NAI)";
      if (feedback == "AIT")
        return "Accomplishment Inconsistent with Target (AIT)";
      if (feedback == "ES") return "Evidence Sufficient (ES)";
      if (feedback == "EIS") return "Evidence Insufficient (EIS)";
      if (feedback == "LSE") return "Label Submitted Evidence (LSE)";
      if (feedback == "NEA") return "No Evidence Attached (NEA)";
      if (feedback == "NAVI") return "No Absolute Value Indicated (NAVI)";
      if (feedback == "KNF") return "KPI not found in approved OPCR (KNF)";
      if (feedback == "KFD")
        return "KPI Found in approved OPCR but Deleted (KFD)";
      if (feedback == "FPD") return "For PMTs Deliberation (FPD)";
      if (feedback == "WDRA") return "Wrong Dimension Rating (QET) as Agreed (WDRA)";
    },
    changeDU(du) {
      this.title = `My Actual ${du.isExternal ? "Deliverables" : "Targets"}`;
      this.items = [
        {
          text: "Dashboards",
          href: "/",
        },
        {
          text: `My Actual ${du.isExternal ? "Deliverables" : "Targets"}`,
          active: true,
        },
      ];
      this.getMyActualTargets(this.$store.state.data.cycle, du.id);
    },
    async printOPCR() {
      var apiUrl = `api/Report/Planning/DU/OPCR`;
      var routeVariables = [this.selectedDU];
      this.$refs.printOpt.putOptions({
        apiUrl: apiUrl,
        routeVariables: routeVariables,
      });
      this.$bvModal.show("print-options-modal");
    },
    printTPMS() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/TPMS",
        routeVariables: [
          this.$store.state.data.cycle,
          this.$store.state.data.selectedDU.id,
        ],
      });
      this.$bvModal.show("print-options-modal");
    },
    printRatedOPCR() {
      this.$refs.printOpt.putOptions({
        apiUrl: "api/Report/Planning/Rated/Opcr",
        routeVariables: [
          this.$store.state.data.cycle,
          this.$store.state.data.selectedDU.id,
        ],
      });
      this.$bvModal.show("print-options-modal");
    },
    calculateAnnualTarget() {
      if (!this.selectedTargetData.mainTarget.isPercentage) {
        let total =
          parseFloat(this.form.q1 ? this.form.q1 : 0) +
          parseFloat(this.form.q2 ? this.form.q2 : 0) +
          parseFloat(this.form.q3 ? this.form.q3 : 0) +
          parseFloat(this.form.q4 ? this.form.q4 : 0);
        this.form.actualAccomplishment = total.toString();
      } else {
        let lastQuarter = 0;
        if (parseFloat(this.form.q1 ? this.form.q1 : 0) != 0)
          lastQuarter = parseFloat(this.form.q1);
        if (parseFloat(this.form.q2 ? this.form.q2 : 0) != 0)
          lastQuarter = parseFloat(this.form.q2);
        if (parseFloat(this.form.q3 ? this.form.q3 : 0) != 0)
          lastQuarter = parseFloat(this.form.q3);
        if (parseFloat(this.form.q4 ? this.form.q4 : 0) != 0)
          lastQuarter = parseFloat(this.form.q4);
        this.form.actualAccomplishment = lastQuarter.toString();
      }
    },
    calculateCascadedTarget() {
      if (!this.interveningTaskForm.isPercentage) {
        let total =
          parseFloat(
            this.interveningTaskForm.q1 ? this.interveningTaskForm.q1 : 0
          ) +
          parseFloat(
            this.interveningTaskForm.q2 ? this.interveningTaskForm.q2 : 0
          ) +
          parseFloat(
            this.interveningTaskForm.q3 ? this.interveningTaskForm.q3 : 0
          ) +
          parseFloat(
            this.interveningTaskForm.q4 ? this.interveningTaskForm.q4 : 0
          );
        this.interveningTaskForm.cascadedTarget = total.toString();
      } else {
        let lastQuarter = 0;
        if (
          parseFloat(
            this.interveningTaskForm.q1 ? this.interveningTaskForm.q1 : 0
          ) != 0
        )
          lastQuarter = parseFloat(this.interveningTaskForm.q1);
        if (
          parseFloat(
            this.interveningTaskForm.q2 ? this.interveningTaskForm.q2 : 0
          ) != 0
        )
          lastQuarter = parseFloat(this.interveningTaskForm.q2);
        if (
          parseFloat(
            this.interveningTaskForm.q3 ? this.interveningTaskForm.q3 : 0
          ) != 0
        )
          lastQuarter = parseFloat(this.interveningTaskForm.q3);
        if (
          parseFloat(
            this.interveningTaskForm.q4 ? this.interveningTaskForm.q4 : 0
          ) != 0
        )
          lastQuarter = parseFloat(this.interveningTaskForm.q4);
        this.interveningTaskForm.cascadedTarget = lastQuarter.toString();
      }
    },
    quarterClass(y, quarter){
      if(this.checkDeadline(false) && this.checkDeadline(true)){
        return 'text-success';
      }
      if(!y.actual.length) return 'text-danger';
      if(y.actual[0][`${quarter}PostedBy`]) return 'text-success';
      if(y.actual[0][`${quarter}ReturnRemarks`] != '' && y.actual[0][`${quarter}ReturnRemarks`] != null) {
        return 'text-warning';
      }
      return '';
    },
    quarterDisplay(y, quarter){
      if(this.checkDeadline(false) && this.checkDeadline(true)){
        return 'Closed/Posted';
      }
      if(!y.actual.length){
        return 'Pending';
      }
      if(y.actual[0][`${quarter}PostedBy`]){
        return 'Posted';
      }
      if(y.actual[0][`${quarter}ReturnRemarks`] != "" && y.actual[0][`${quarter}ReturnRemarks`] != null){
        return 'Returned';
      }
      return 'Pending';
    },
    borderClass(form, quarter){
      if(this.checkDeadline(false) && this.checkDeadline(true)) {
        return 'border-success border-2';
      }
      if(form[`${quarter}PostedBy`]){
        return 'border-success border-2';
      }
      if(this.checkDeadline(false) && !this.checkDeadline(true) && form[`${quarter}ReturnRemarks`] != '' && form[`${quarter}ReturnRemarks`] != null){
        return 'border-warning border-2';
      }
      if(this.checkDeadline(false) && !this.checkDeadline(true) && !form[`${quarter}PostedBy`]){
        return 'border-danger border-2';
      }
      return '';
    },
    checkIfReturned(form, quarter) {
      if(this.checkDeadline(true)) return false;
      if(form[`${quarter}ReturnRemarks`] != '' && form[`${quarter}ReturnRemarks`] != null) {
        return true;
      }
      return false;
    },
    canEdit(form, quarter) {
      if(this.checkDeadline(true)) return false;
      if(form.status && form.status.toUpperCase().includes('RETURNED')) {
        return true;
      }
      if(form[`${quarter}ReturnRemarks`] != '' && form[`${quarter}ReturnRemarks`] != null) {
        return true;
      }
      if(!form[`${quarter}PostedBy`]) {
        return true;
      }
      return false;
    },
    alreadySavedQuarter(quarter){
      if(quarter == 1){
        return this.alreadySavedQ1;
      }
      if(quarter == 2){
        return this.alreadySavedQ2;
      }
      if(quarter == 3){
        return this.alreadySavedQ3;
      }
      if(quarter == 4){
        return this.alreadySavedQ4;
      }
      return false;
    }
  },
};
</script>

<template>
  <Layout @changeCycle="changeCycle" @changeDU="changeDU">
    <PageHeader :title="title" :items="items" />
    <!-- Intervening Task -->
    <b-modal id="modal-interveningTask" title="Add Intervening Task" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <form @submit.prevent="onAddInterveningTask" class="needs-validation" ref="targetForm">
        <div>
          <label>Target Description</label>
          <textarea class="form-control" placeholder="Type Target Description Here..." rows="5"
            v-model="interveningTaskForm.remarks" :class="{
              'is-invalid': submitted && $v.interveningTaskForm.remarks.$error,
            }"></textarea>
        </div>
        <div class="my-3">
          <label class="m-0">Quarterly Target</label>
          <div class="mb-2">
            <div class="d-flex align-items-center">
              <switches v-model="interveningTaskForm.isPercentage" id="isPercentage" @input="calculateCascadedTarget">
              </switches>
              <label for="isPercentage" class="mx-2">
                <span v-if="interveningTaskForm.isPercentage">Percentage</span>
                <del v-else>Percentage</del>
              </label>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <masked-input type="text" class="form-control w-100 text-center" placeholder="Quarter 1"
                  v-model="interveningTaskForm.q1" :mask="currencyMask" @input="calculateCascadedTarget" :class="{
                    'is-invalid': submitted && $v.interveningTaskForm.q1.$error,
                  }"></masked-input>
                <b v-if="interveningTaskForm.isPercentage" class="ms-2">%</b>
              </div>
              <div class="text-center">
                <small>Quarter 1</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <masked-input type="text" class="form-control w-100 text-center" placeholder="Quarter 2"
                  v-model="interveningTaskForm.q2" :mask="currencyMask" @input="calculateCascadedTarget" :class="{
                    'is-invalid': submitted && $v.interveningTaskForm.q2.$error,
                  }"></masked-input>
                <b v-if="interveningTaskForm.isPercentage" class="ms-2">%</b>
              </div>
              <div class="text-center">
                <small>Quarter 2</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <masked-input type="text" class="form-control w-100 text-center" placeholder="Quarter 3"
                  v-model="interveningTaskForm.q3" :mask="currencyMask" @input="calculateCascadedTarget" :class="{
                    'is-invalid': submitted && $v.interveningTaskForm.q3.$error,
                  }"></masked-input>
                <b v-if="interveningTaskForm.isPercentage" class="ms-2">%</b>
              </div>
              <div class="text-center">
                <small>Quarter 3</small>
              </div>
            </div>
            <div class="col-md-3">
              <div class="d-flex align-items-center">
                <masked-input type="text" class="form-control w-100 text-center" placeholder="Quarter 4"
                  v-model="interveningTaskForm.q4" :mask="currencyMask" @input="calculateCascadedTarget" :class="{
                    'is-invalid': submitted && $v.interveningTaskForm.q4.$error,
                  }"></masked-input>
                <b v-if="interveningTaskForm.isPercentage" class="ms-2">%</b>
              </div>
              <div class="text-center">
                <small>Quarter 4</small>
              </div>
            </div>
          </div>
        </div>
        <div class="mt-2 mb-3">
          <label>Annual Target</label>
          <div class="d-flex align-items-center">
            <masked-input type="text" class="form-control w-100" placeholder="Annual Target"
              v-model="interveningTaskForm.cascadedTarget" :mask="currencyMask" :class="{
                'is-invalid':
                  submitted && $v.interveningTaskForm.cascadedTarget.$error,
              }"></masked-input>
            <b v-if="interveningTaskForm.isPercentage" class="ms-2">%</b>
          </div>
        </div>
        <div class="modal-footer">
          <button type="submit" class="btn btn-primary">Save changes</button>
        </div>
      </form>
    </b-modal>
    <!-- Actual -->
    <b-modal id="modal-actual" :title="modalTitle" size="lg" title-class="font-18" hide-footer no-close-on-backdrop
      no-close-on-esc @close="closeModal">
      <div v-if="ratingLoading" class="d-flex justify-content-center align-items-center p-3">
        <div class="preloader-component me-2">
          <div class="status">
            <div class="spinner-chase w-20px h-20px">
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
              <div class="chase-dot"></div>
            </div>
          </div>
        </div>
        <strong>Loading...</strong>
      </div>
      <div v-else-if="selectedTargetData" class="px-2 pb-3">
        <h5 class="mb-3 text-center">
          <span class="text-warning">{{ selectedTargetData.remarks }}</span>
        </h5>
        <div class="border">
          <div class="d-flex flex-wrap">
            <template v-for="x in 4">
              <div class="w-50 border p-3" :class="borderClass(form, `q${x}`)" :key="x">
                <div class="d-flex justify-content-between gap-5">
                  <div>
                    <b class="font-size-14 text-white">Quarter {{ x }}</b>
                    <div class="text-warning">
                      Target: {{ selectedTargetData.mainTarget.isPercentage ? row[`q${x}`] + "%" : row[`q${x}`] }}
                    </div>
                  </div>
                  <div>
                    <div class="mb-1">
                      <button type="button" class="btn btn-sm btn-purple btn-block" style="min-width: max-content"
                        @click="viewQuarterAttachment(x, form[`q${x}PostedBy`])">
                        <i class="bx bx-paperclip"></i> View Mode of Verification
                      </button>
                    </div>
                    <div>
                      <button 
                        v-if="!form[`q${x}PostedBy`] && form[`q${x}ReturnRemarks`] != '' && form[`q${x}ReturnRemarks`] != null" 
                        type="button" 
                        class="btn btn-sm btn-pink btn-block" 
                        style="min-width: max-content" 
                        @click="viewQuarterReturnRemarks(form[`q${x}ReturnRemarks`], `Quarter ${x} Return Remarks`)"
                      >
                        <i class="mdi mdi-format-list-numbered"></i> Return
                        Remarks
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div class="d-flex align-items-center my-2">
                  <span class="me-2">Actual</span>
                  <masked-input 
                    autocomplete="off" 
                    :id="`q${x}`" 
                    type="text" 
                    v-model="form[`q${x}`]"
                    placeholder="Enter Quarter 1 Value ..." 
                    class="form-control" 
                    :class="{ 'is-invalid': submitted && $v.form[`q${x}`].$error}" 
                    :mask="currencyMask" 
                    v-if="!form[`q${x}PostedBy`]" 
                    @input="calculateAnnualTarget">
                  </masked-input>
                  <input type="text" class="form-control" disabled v-else :value="form[`q${x}`]" />
                  <b v-if="selectedTargetData.mainTarget.isPercentage" class="ms-2">%</b>
                </div>
                <div class="d-flex align-items-center my-2">
                  <textarea autocomplete="off" :id="`q${x}Remarks`" :ref="`q${x}Remarks`" :rows="`${q1RemarksLines}`"
                    v-model="form[`q${x}Remarks`]" :placeholder="`Enter Quarter ${x} Remarks...`" class="form-control resize-none"
                    @input="autoGrow($event, 15)" v-if="!form[`q${x}PostedBy`]"></textarea>
                  <div style="white-space: break-spaces" v-else class="form-control">
                    {{ form[`q${x}Remarks`].toString() }}
                  </div>
                </div>
                <div class="text-center">
                  <div v-if="canEdit(form, `q${x}`)" class="d-flex align-items-center justify-content-center gap-2">
                    <button type="button" class="btn btn-primary w-50" @click="onCreate(false)" v-if="!form[`q${x}PostedBy`]">
                      <i class="bx bx-save"></i>
                      {{ alreadySavedQuarter(`q${x}`) ? "Update" : "Save" }} Changes
                    </button>
                    <button type="button" class="btn btn-success w-50" @click="postQuarter(x)" v-if="!form[`q${x}PostedBy`]">
                      <i class="bx bx-check"></i> Post this quarter
                    </button>
                  </div>
                  <div>
                    <div class="text-success text-center font-size-20" v-if="checkDeadline(true)">
                      <b>Posted/Closed</b>
                    </div>
                    <div class="text-center font-size-20" v-else-if="checkDeadline(false) && !form[`q${x}PostedBy`]">
                      <b v-if="checkIfReturned(form, `q${x}`)" class="text-warning">Returned</b>
                      <b v-else class="text-danger">{{form[`q${x}PostedBy`] ? 'Posted': 'Closed'}}</b>
                    </div>
                    <div v-else-if="
                      selectedTargetData.actual.length &&
                      selectedTargetData.actual[0][`q${x}ReturnExpiry`] != null &&
                      !form[`q${x}PostedBy`] &&
                      form[`q${x}ReturnRemarks`] != '' &&
                      form[`q${x}ReturnRemarks`] != null
                    " class="text-center text-warning font-size-14 mt-3">
                      <b v-if="returnDeadline">Deadline:
                        {{
                          formatDateWithTime(new Date(returnDeadline.deadline))
                        }}</b>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
        </div>
        <div class="mt-3 d-flex gap-2">
          <div class="w-50">
            <label for="annualTarget"><b class="text-white">Annual Target</b></label>
            <div class="d-flex align-items-center justify-content-center gap-2">
              <masked-input type="text" class="form-control" placeholder="Annual Target" v-model="form.annualTarget"
                :mask="currencyMask" :disabled="alreadySaved" />
              <b v-if="selectedTargetData.mainTarget.isPercentage" class="me-2">%</b>
            </div>
          </div>
          <div class="w-50">
            <label for="annualTarget"><b class="text-white">Actual Accomplishment</b></label>
            <div class="d-flex align-items-center justify-content-center gap-2">
              <masked-input type="text" class="form-control" placeholder="Actual Accomplishment"
                v-model="form.actualAccomplishment" :mask="currencyMask" :disabled="alreadySaved" />
              <b v-if="selectedTargetData.mainTarget.isPercentage" class="me-2">%</b>
            </div>
          </div>
        </div>
        <div v-if="checkPostedQuarter()">
          <div class="mt-3">
            <div class="row">
              <div class="col-4">
                <label for="scoreQuality"><b class="text-white">Effectiveness / Quality</b></label>
                <multiselect :disabled="alreadySaved" @select="onQETSelect" track-by="rating"
                  :placeholder="form.scoreQuality.toString()" :show-labels="false" :options="qualityOptions"
                  :searchable="false" :allow-empty="true" :class="{
                    'is-invalid':
                      submitted &&
                      form.scoreQuality == 0 &&
                      form.scoreEfficiency == 0 &&
                      form.scoreTimeliness == 0,
                  }">
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
                      <b class="option__title">{{ option.rating }}</b>
                      -
                      <span class="option__small">{{
                        option.description
                      }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="col-4">
                <label for="scoreEfficiency"><b class="text-white">Efficiency</b></label>
                <multiselect :disabled="alreadySaved" @select="onQETSelect" track-by="rating"
                  :placeholder="form.scoreEfficiency.toString()" :show-labels="false" :options="efficiencyOptions"
                  :searchable="false" :allow-empty="true" :class="{
                    'is-invalid':
                      submitted &&
                      form.scoreQuality == 0 &&
                      form.scoreEfficiency == 0 &&
                      form.scoreTimeliness == 0,
                  }">
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
                      <b class="option__title">{{ option.rating }}</b>
                      -
                      <span class="option__small">{{
                        option.description
                      }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
              <div class="col-4">
                <label for="scoreTimeliness"><b class="text-white">Timeliness</b></label>
                <multiselect :disabled="alreadySaved" @select="onQETSelect" track-by="rating"
                  :placeholder="form.scoreTimeliness.toString()" :show-labels="false" :options="timelinessOptions"
                  :searchable="false" :allow-empty="true" :class="{
                    'is-invalid':
                      submitted &&
                      form.scoreQuality == 0 &&
                      form.scoreEfficiency == 0 &&
                      form.scoreTimeliness == 0,
                  }">
                  <template slot="option" slot-scope="{ option }">
                    <div class="option__desc">
                      <b class="option__title">{{ option.rating }}</b>
                      -
                      <span class="option__small">{{
                        option.description
                      }}</span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <div class="d-flex justify-content-between gap-5">
              <div class="pt-2">
                <label for="catchUpPlans"><b class="text-white">Catchup Plan / Justification</b></label>
              </div>
              <div>
                <button type="button" class="btn btn-sm btn-purple btn-block" style="min-width: max-content"
                  @click="viewCatchupAttachment(alreadySaved)">
                  <i class="bx bx-paperclip"></i> Attachments
                </button>
              </div>
            </div> <textarea id="catchUpPlans" rows="1" v-model="form.catchUpPlans"
              placeholder="Catchup Plan / Justification..." class="form-control resize-none"
              @input="autoGrow($event, 15)" ref="catchupPlans" :disabled="alreadySaved"></textarea>
          </div>
          <div class="mt-3">
            <label for="finalRemarks"><b class="text-white">Final Remarks</b></label> <textarea id="finalRemarks"
              rows="1" v-model="form.finalRemarks" placeholder="Final Remarks..." class="form-control resize-none"
              :class="{
                'is-invalid': submitted && form.finalRemarks == '',
              }" @input="autoGrow($event, 15)" ref="finalRemarks" :disabled="alreadySaved"></textarea>
          </div>
          <div class="mt-3 submission-status">
            <!-- Saved and closed state -->
            <div v-if="alreadySaved"
              class="alert alert-success py-2 d-flex align-items-center justify-content-center mb-3">
              <i class="bx bx-check-circle me-2 font-size-18"></i>
              <b>Submission Confirmed</b>
            </div>
            <!-- Closed without saving -->
            <div v-else-if="checkDeadline(true)"
              class="alert alert-danger py-2 d-flex align-items-center justify-content-center">
              <i class="bx bx-lock me-2 font-size-18"></i>
              <b>Submission Closed</b>
            </div>
            <!-- Open submission state - whether saved before or not -->
            <div v-else>
              <button type="button" class="btn btn-primary btn-block mt-1" @click="saveFinal">
                <i class="bx bx-save"></i>
                Save & Finish
              </button>
            </div>
            <!-- Saved and closed state -->
            <!-- <div v-if="alreadySaved && checkDeadline(true)"
              class="alert alert-warning py-2 d-flex align-items-center justify-content-center">
              <i class="bx bx-lock-alt me-2 font-size-18"></i>
              <b>Submission Closed - Previously Saved</b>
            </div> -->
            <!-- Closed without saving -->
            <!-- <div v-else-if="checkDeadline(true)"
              class="alert alert-danger py-2 d-flex align-items-center justify-content-center">
              <i class="bx bx-lock me-2 font-size-18"></i>
              <b>Submission Closed - Not Saved</b>
            </div> -->
            <!-- Open submission state - whether saved before or not -->
            <!-- <div v-else> -->
            <!-- Success message when previously saved -->
            <!-- <div v-if="alreadySaved"
                class="alert alert-success py-2 d-flex align-items-center justify-content-center mb-3">
                <i class="bx bx-check-circle me-2 font-size-18"></i>
                <b>Previously Saved - You can still update</b>
              </div> -->
            <!-- Save/Update button - always shown when deadline not passed -->
            <!-- <button type="button" class="btn btn-primary btn-block mt-1" @click="saveFinal">
                <i class="bx bx-save"></i> {{ alreadySaved ? "Update & Finish" : "Save & Finish" }}
              </button> -->
            <!-- </div> -->
          </div>
        </div>
      </div>
    </b-modal>
    <!-- Quarter Attachments -->
    <b-modal id="modal-quarterAttachments" :title="modalTitle" size="lg" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc>
      <b-row>
        <b-col>
          <h5 v-if="attachmentLoading">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <div class="d-flex justify-content-center align-items-center ms-4 font-size-14">
                  <div class="preloader-component me-2">
                    <div class="status">
                      <div class="spinner-chase w-20px h-20px">
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                        <div class="chase-dot"></div>
                      </div>
                    </div>
                  </div>
                  <strong>Loading...</strong>
                </div>
              </div>
            </div>
          </h5>
          <div class="row mb-3" v-else>
            <div v-for="mov in movData" :key="mov.id">
              <div class="d-flex justify-content-between mb-2">
                <label class="text-white font-size-14">{{ mov.mode }}</label>
                <div v-if="attWActions">
                  <button type="button" @click="mov.addDocu = true" class="btn btn-sm btn-outline-info"
                    :id="`quarter-document${mov.id}`">
                    <i class="mdi mdi-upload fs-6"></i>
                    Upload Documents
                  </button>
                  <upload-popover :option="mov.uploadOptions" :sourceId="mov.targetId" @uploaded="
                    uploadedDocument($event, mov.targetId, 'Quarter', mov.id)
                    " :showPV="mov.addDocu" @closePopover="mov.addDocu = false" :dzId="`dropzone-target${mov.id}`"
                    :pvId="`quarter-document${mov.id}`"></upload-popover>
                </div>
              </div>
              <div class="border-bottom p-2 mb-3">
                <b v-if="
                  filterDocuByType(
                    mov.attachments,
                    `Quarter ${attachmentQuarter} Files: ${mov.mode}`,
                    `Quarter ${attachmentQuarter} Files: ${mov.id}`
                  ).length == 0
                ">
                  No document found.
                </b>
                <div class="row mb-3">
                  <div class="col-md-4" v-for="(z, index) in filterDocuByType(
                    mov.attachments,
                    `Quarter ${attachmentQuarter} Files: ${mov.mode}`,
                    `Quarter ${attachmentQuarter} Files: ${mov.id}`
                  )" :key="z.id">
                    <div class="position-relative cursor-pointer border br-5 mb-2" :style="`z-index: ${filterDocuByType(
                      mov.attachments,
                      `Quarter ${attachmentQuarter} Files: ${mov.mode}`,
                      `Quarter ${attachmentQuarter} Files: ${mov.id}`
                    ).length - index
                      }`">
                      <div class="border p-3">
                        <div>
                          <div class="float-end ms-2" v-if="attWActions">
                            <b-dropdown id="dropdown-dropleft" right variant="link"
                              toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                              menu-class="dropdown-menu-end" no-caret>
                              <template #button-content>
                                <i class="mdi mdi-dots-horizontal"></i>
                              </template>
                              <b-dropdown-item @click="openDocument(z)"><i
                                  class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                              <b-dropdown-item variant="danger" @click="removeQuarterFile(z.id, mov.id)"><i
                                  class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                            </b-dropdown>
                          </div>
                          <div @click="openDocument(z)">
                            <div class="avatar-xs me-3 mb-2">
                              <div class="avatar-title bg-transparent rounded">
                                <i v-if="z.fileType.includes('image')"
                                  class="mdi mdi-image font-size-24 text-purple"></i>
                                <i v-if="z.fileType.includes('application')"
                                  class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                              </div>
                            </div>
                            <div class="d-flex">
                              <div class="overflow-hidden me-auto">
                                <h5 class="font-size-14 text-truncate mb-1">
                                  {{ z.description }}
                                </h5>
                                <p class="text-muted mb-0">
                                  {{
                                    formatDateWithTime(
                                      new Date(z.dateTimeUploaded)
                                    )
                                  }}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-modal>
    <!-- Logs -->
    <b-modal id="return-remarks-modal" title="Accomplishment Logs" size="md" title-class="font-18" hide-footer
      no-close-on-backdrop no-close-on-esc @close="closeModal">
      <ul class="verti-timeline list-unstyled ms-3" v-for="(remark, index) in returnRemarks" :key="index">
        <li class="event-list" :class="{
          active: index == 0,
        }">
          <div class="event-timeline-dot">
            <i class="font-size-18" :class="index == 0
              ? 'bx bxs-right-arrow-circle bx-fade-right'
              : 'bx bx-right-arrow-circle'
              "></i>
          </div>
          <div class="media">
            <div class="me-3 mb-3">
              <h5 class="font-size-14 mb-0">
                {{ remark.splitted[0] }}
                <i class="bx bx-right-arrow-alt font-size-16 text-primary align-middle ms-2"></i>
              </h5>
              <small>{{ remark.splitted[1] }}</small>
            </div>
            <div class="media-body">
              <div class="mb-0" style="line-height: 14px">
                {{ remark.Remarks }}
              </div>
              <div>
                <small>({{ remark.Employee }})</small>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </b-modal>
    <div class="p-5 d-flex align-items-center justify-content-center" v-if="tableBusy">
      <div class="preloader-component me-2">
        <div class="status">
          <div class="spinner-chase w-25px h-25px">
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
            <div class="chase-dot"></div>
          </div>
        </div>
      </div>
      <h5 class="mb-0">Loading...</h5>
    </div>
    <div v-else-if="tableData.length == 0" class="p-5 text-center">
      <h5>No data available</h5>
    </div>
    <div v-else class="position-relative">
      <div v-if="accomplishmentDeadline || returnDeadline" class="border p-3 mb-3 col-5">
        <span>
          <span>The deadline </span>
          <span v-if="accomplishmentDeadline">for submitting quarterly accomplishments is on
            <b :class="new Date(accomplishmentDeadline.deadline) < new Date()
              ? 'text-danger'
              : 'text-success'
              ">{{
                formatDateWithTime(new Date(accomplishmentDeadline.deadline))
              }}</b></span>
          <span v-if="
            accomplishmentDeadline &&
            returnDeadline &&
            new Date(accomplishmentDeadline.deadline) <
            new Date(returnDeadline.deadline)
          ">, while the cutoff
          </span>
          <span v-if="
            returnDeadline &&
            new Date(accomplishmentDeadline.deadline) <
            new Date(returnDeadline.deadline)
          ">for reposting returned quarterly accomplishments is on
            <b :class="new Date(returnDeadline.deadline) < new Date()
              ? 'text-danger'
              : 'text-success'
              ">{{ formatDateWithTime(new Date(returnDeadline.deadline)) }}</b></span>.
        </span>
      </div>
      <div class="text-right position-absolute" style="right: 0">
        <button @click="addInterveningTask()" type="button" class="btn btn-sm btn-success me-2">
          <i class="bx bx-plus me-1"></i>
          Add Intervening Task
        </button>
        <b-dropdown id="dropdown-dropleft" right variant="purple btn-sm" toggle-class="text-decoration-none"
          menu-class="dropdown-menu-end" no-caret>
          <template #button-content>
            <i class="bx bx-printer me-1"></i>
            Reports
          </template>
          <b-dropdown-item @click="printTPMS()">TPMS</b-dropdown-item>
          <b-dropdown-item @click="printRatedOPCR()">Rated OPCR</b-dropdown-item>
        </b-dropdown>
      </div>
      <b-tabs content-class="pt-3 pb-3 text-muted" v-model="tabIndex" nav-class="nav-tabs-custom">
        <div v-for="(type, index) in tabOptions" :key="index">
          <b-tab v-if="checkTab(type)" @click="
            filter = '';
          tabSelect = type;
          perPage = 10;
          currentPage = 1;
          ">
            <template v-slot:title>
              <div v-if="typeNotifCount(type)" class="position-absolute" style="top: -5px; left: 1px">
                <span class="badge bg-danger rounded-pill">{{
                  typeNotifCount(type)
                }}</span>
              </div>
              <span class="d-inline-block d-sm-none">
                <i class="mdi mdi-clock-time-four-outline"></i>
              </span>
              <span class="d-none d-sm-inline-block">{{ type }}</span>
            </template>
            <div v-if="tabSelect == type">
              <div class="row">
                <div class="col-12">
                  <div class="card border-4 border-top border-start-0 border-end-0 border-primary table-responsive"
                    style="min-width: 1070px">
                    <div class="card-body">
                      <div class="d-flex align-items-center justify-content-between">
                        <h4 class="card-title m-0">KPI List</h4>
                      </div>
                      <div>
                        <div class="row mt-2">
                          <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_length" class="dataTables_length">
                              <label class="d-inline-flex align-items-center">
                                Show&nbsp;
                                <b-form-select class="form-select form-select-sm" v-model="perPage" size="sm"
                                  :options="pageOptions"></b-form-select>&nbsp;entries
                              </label>
                            </div>
                          </div>
                          <!-- Search -->
                          <div class="col-sm-12 col-md-6">
                            <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                              <label class="d-inline-flex align-items-center">
                                Search:
                                <b-form-input autocomplete="off" v-model="filter" type="search"
                                  placeholder="Search KPI, Target..."
                                  class="form-control form-control-sm ms-2"></b-form-input>
                              </label>
                            </div>
                          </div>
                          <!-- End search -->
                        </div>
                        <div v-if="paginatedData.length == 0" class="text-center">
                          <h5 v-if="filter">Search not found</h5>
                          <h5 v-else>No data available</h5>
                        </div>
                        <div role="tablist" v-for="(x, xIndex) in paginatedData" :key="x.indicatorItemId">
                          <b-card no-body class="mb-2 shadow-none" :style="{
                            'z-index': paginatedData.length - xIndex,
                          }">
                            <div v-if="kpiNotifCount(x.details) > 0" class="position-absolute"
                              style="top: -5px; left: -5px">
                              <span class="badge bg-danger rounded-pill">{{
                                kpiNotifCount(x.details)
                              }}</span>
                            </div>
                            <b-card-header header-tag="header" role="tab" header-class="cursor-pointer border">
                              <div class="d-flex justify-content-between align-items-center" @click="
                                x.showTargets = !x.showTargets;
                              $forceUpdate();
                              ">
                                <div class="me-3">
                                  <div>
                                    <b class="text-white">
                                      <a class="text-dark" href="javascript: void(0);">{{ x.indicatorItemName }}</a>
                                    </b>
                                  </div>
                                  <small>
                                    Targets Available ({{ x.details.length }})
                                  </small>
                                </div>
                                <div class="d-flex align-items-center">
                                  <div>
                                    <span class="d-flex align-items-center"><small v-if="!x.showTargets">Click here to
                                        expand</small>
                                      <div class="d-flex align-items-center">
                                        <i class="bx bx-chevron-right rotate font-size-18 ms-3" :class="{
                                          'rotate-90': x.showTargets,
                                        }"></i>
                                      </div>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </b-card-header>
                            <b-collapse :visible="x.showTargets"
                              :accordion="`kpi-accordion-${type}-${x.indicatorItemId}`" role="tabpanel">
                              <b-card-body v-if="x.showTargets" class="ps-5 pe-0 pt-3">
                                <div class="d-flex align-items-center">
                                  <h6 class="card-title text-muted">
                                    {{ titleList }}
                                    List
                                  </h6>
                                </div>
                                <div role="tablist" v-for="(y, yIndex) in x.details" :key="y.id">
                                  <b-card no-body class="mb-2 shadow-none" :style="{
                                    'z-index': x.details.length - yIndex,
                                  }">
                                    <RawData :data="y" v-if="$store.state.decrypt.isAdmin()"
                                      :keyId="`${type}-KPI${x.indicatorItemId}-Target${y.id}`" />
                                    <b-card-header header-tag="header" role="tab" header-class="cursor-pointer border">
                                      <div class="d-flex justify-content-between align-items-center"
                                        @click="getDepartmentsByTarget(y)">
                                        <div class="d-flex align-items-center">
                                          <div class="bg-gradient text-center me-2 py-1 position-relative" :class="{
                                            'bg-danger': y.notification,
                                            'bg-success': !y.notification,
                                          }" style="min-width: 30px">
                                            <h3 class="mb-0 position-relative">
                                              {{ yIndex + 1 }}
                                            </h3>
                                          </div>
                                          <div>
                                            <h6 class="mb-0">
                                              <a class="text-dark" href="javascript: void(0);">{{ y.remarks }}</a>
                                            </h6>
                                          </div>
                                        </div>
                                        <div class="d-flex align-items-center">
                                          <div>
                                            <i class="bx bx-chevron-right rotate font-size-18 ms-3" :class="{
                                              'rotate-90': y.showDetails,
                                            }"></i>
                                          </div>
                                        </div>
                                      </div>
                                    </b-card-header>
                                    <b-collapse :visible="y.showDetails" :accordion="`target-accordion-${type}-${y.id}`"
                                      role="tabpanel">
                                      <b-card-body v-if="y.showDetails" class="border px-2 py-2">
                                        <ul class="mt-2">
                                          <li>
                                            <div
                                              class="d-flex align-items-center justify-content-between cursor-pointer"
                                              @click="
                                                y.detailVisible =
                                                !y.detailVisible
                                                ">
                                              <div>
                                                <h6 class="mb-0 text-info">
                                                  <i class="bx bx-receipt"></i>
                                                  Target Details
                                                </h6>
                                              </div>
                                              <h5 class="mb-0">
                                                <i class="bx bx-chevron-right rotate" :class="{
                                                  'rotate-90':
                                                    y.detailVisible,
                                                }"></i>
                                              </h5>
                                            </div>
                                            <b-collapse :visible="y.detailVisible"
                                              :accordion="`target-detail-accordion-${type}-${y.id}`" role="tabpanel">
                                              <hr />
                                              <div>
                                                <div class="d-flex gap-3 mt-3">
                                                  <div class="col-md-4">
                                                    <div class="mb-2">
                                                      <div class="d-flex gap-2">
                                                        <label class="text-white">Assigned
                                                          Departments:</label>
                                                      </div>
                                                      <div class="d-flex">
                                                        <div class="form-control">
                                                          <span v-if="
                                                            !y.assignedDepartments ||
                                                            (y.assignedDepartments &&
                                                              y
                                                                .assignedDepartments
                                                                .length == 0)
                                                          " class="text-warning">N/A</span>
                                                          <span class="badge bg-purple me-1 font-size-14 my-1"
                                                            v-for="department in y.assignedDepartments"
                                                            :key="department.id"><b class="font-size-11">{{
                                                              department.department
                                                            }}</b></span>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="mb-2">
                                                      <div class="d-flex gap-2">
                                                        <label class="text-white">Departments:</label>
                                                      </div>
                                                      <div class="form-control">
                                                        <span v-if="
                                                          !y.departmentList ||
                                                          (y.departmentList &&
                                                            y.departmentList
                                                              .length == 0)
                                                        " class="text-warning">N/A</span>
                                                        <span class="badge bg-purple me-1 font-size-14 my-1"
                                                          v-for="department in y.departmentList" :key="department.id"><b
                                                            class="font-size-11">{{
                                                              department.departmentName
                                                            }}</b></span>
                                                      </div>
                                                    </div>
                                                    <!-- <div class="mb-2">
                                                      <label class="text-white"
                                                        >Item Name:</label
                                                      >
                                                      <div
                                                        class="form-control text-warning"
                                                      >
                                                        {{
                                                          y.mainTarget
                                                            .indicatorItem
                                                            .indicatorItemName
                                                            ? y.mainTarget
                                                                .indicatorItem
                                                                .indicatorItemName
                                                            : "N/A"
                                                        }}
                                                      </div>
                                                    </div>
                                                    <div class="mb-2">
                                                      <label class="text-white"
                                                        >Type:</label
                                                      >
                                                      <div
                                                        class="form-control text-warning"
                                                      >
                                                        {{
                                                          y.mainTarget
                                                            .indicatorItem.type
                                                            ? y.mainTarget
                                                                .indicatorItem
                                                                .type
                                                            : "N/A"
                                                        }}
                                                      </div>
                                                    </div>
                                                    <div class="mb-2">
                                                      <label class="text-white"
                                                        >Final Remarks:</label
                                                      >
                                                      <div
                                                        class="form-control text-warning"
                                                      >
                                                        {{
                                                          y.mainTarget
                                                            .indicatorItem
                                                            .finalRemarks
                                                            ? y.mainTarget
                                                                .indicatorItem
                                                                .finalRemarks
                                                            : "N/A"
                                                        }}
                                                      </div>
                                                    </div> -->
                                                    <div class="mb-2">
                                                      <label class="text-white">Annual Target:</label>
                                                      <div class="form-control text-warning">
                                                        {{
                                                          y.annualTarget
                                                            ? y.annualTarget
                                                            : getAnnualTarget(
                                                              y,
                                                              y.mainTarget
                                                                .isPercentage
                                                            )
                                                        }}{{
                                                          y.mainTarget
                                                            .isPercentage
                                                            ? "%"
                                                            : ""
                                                        }}
                                                      </div>
                                                    </div>
                                                    <div class="mb-2">
                                                      <label class="text-white">Actual
                                                        Accomplishment:</label>
                                                      <div class="form-control text-warning">
                                                        {{
                                                          y.actualAccomplishment
                                                            ? y.actualAccomplishment
                                                            : 0
                                                        }}{{
                                                          y.mainTarget
                                                            .isPercentage
                                                            ? "%"
                                                            : ""
                                                        }}
                                                      </div>
                                                    </div>
                                                    <div class="mb-2">
                                                      <label class="m-0 text-white">Self Rating:</label>
                                                      <div class="row">
                                                        <div class="col-4">
                                                          <label class="font-size-12 text-white">Effectiveness /
                                                            Quality</label>
                                                        </div>
                                                        <div class="col-4">
                                                          <label class="font-size-12 text-white">Efficiency</label>
                                                        </div>
                                                        <div class="col-4">
                                                          <label class="font-size-12 text-white">Timeliness</label>
                                                        </div>
                                                      </div>
                                                      <div class="row">
                                                        <div class="col-4">
                                                          <div class="form-control text-warning">
                                                            {{ y.scoreQuality }}
                                                          </div>
                                                        </div>
                                                        <div class="col-4">
                                                          <div class="form-control text-warning">
                                                            {{
                                                              y.scoreEfficiency
                                                            }}
                                                          </div>
                                                        </div>
                                                        <div class="col-4">
                                                          <div class="form-control text-warning">
                                                            {{
                                                              y.scoreTimeliness
                                                            }}
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div>
                                                      <label class="text-white">Other Info:</label>
                                                      <div class="d-flex align-items-center mb-1">
                                                        <span class="d-flex align-items-center border p-1 me-2">
                                                          <i class="bx font-size-18 font-weight-bolder bx-x text-danger"
                                                            v-if="
                                                              !y.mainTarget
                                                                .isPercentage
                                                            "></i>
                                                          <i class="bx font-size-18 font-weight-bolder bx-check text-success"
                                                            v-if="
                                                              y.mainTarget
                                                                .isPercentage
                                                            "></i>
                                                          <div>
                                                            Percentage
                                                          </div>
                                                        </span><span class="d-flex align-items-center border p-1 me-2">
                                                          <i class="bx font-size-18 font-weight-bolder bx-x text-danger"
                                                            v-if="
                                                              !y.mainTarget
                                                                .indicatorItem
                                                                .isCompleted
                                                            "></i>
                                                          <i class="bx font-size-18 font-weight-bolder bx-check text-success"
                                                            v-if="
                                                              y.mainTarget
                                                                .indicatorItem
                                                                .isCompleted
                                                            "></i>
                                                          <div>
                                                            Completed
                                                          </div>
                                                        </span><span class="d-flex align-items-center border p-1 me-1">
                                                          <i class="bx font-size-18 font-weight-bolder bx-x text-danger"
                                                            v-if="
                                                              !y.mainTarget
                                                                .indicatorItem
                                                                .isRecurring
                                                            "></i>
                                                          <i class="bx font-size-18 font-weight-bolder bx-check text-success"
                                                            v-if="
                                                              y.mainTarget
                                                                .indicatorItem
                                                                .isRecurring
                                                            "></i>
                                                          <div>
                                                            Recurring
                                                          </div>
                                                        </span>
                                                      </div>
                                                    </div>
                                                  </div>
                                                  <div style="width: 100%">
                                                    <div class="ps-5 table-responsive">
                                                      <div class="d-flex justify-content-between" style="
                                                          min-width: max-content;
                                                        ">
                                                        <div class="d-flex align-items-center mb-2">
                                                          <span class="d-flex align-items-center border p-1 me-1" style="
                                                              width: max-content;
                                                            ">
                                                            <i class="bx font-size-18 font-weight-bolder bx-check text-success"
                                                              v-if="
                                                                y.actual
                                                                  .length &&
                                                                y.actual[0]
                                                                  .status.toLowerCase() ==
                                                                'posted'
                                                              "></i>
                                                            <i class="bx font-size-18 font-weight-bolder bx-x text-danger"
                                                              v-else-if="
                                                                checkDeadline(
                                                                  checkReturnStatus(
                                                                    y
                                                                  )
                                                                )
                                                              "></i>
                                                            <i class="bx font-size-18 font-weight-bolder bx-undo text-warning"
                                                              v-else-if="
                                                                checkReturnStatus(
                                                                  y
                                                                )
                                                              "></i>
                                                            <i class="bx font-size-18 font-weight-bolder bx-time"
                                                              v-else-if="
                                                                y.actual
                                                                  .length ==
                                                                0 ||
                                                                (y.actual
                                                                  .length > 0 &&
                                                                  y.actual[0]
                                                                    .status.toLowerCase() ==
                                                                  'pending')
                                                              "></i>
                                                            <div class="mx-1">
                                                              {{
                                                                checkDeadline(
                                                                  checkReturnStatus(
                                                                    y
                                                                  )
                                                                )
                                                                  ? "CLOSED"
                                                                  : checkReturnStatus(
                                                                    y
                                                                  )
                                                                    ? "RETURNED"
                                                                    : y.actual
                                                                      .length ==
                                                                      0
                                                                      ? "Pending"
                                                                      : y.actual[0]
                                                                        .status
                                                              }}
                                                            </div>
                                                          </span>
                                                          <b v-if="
                                                            y.actual.length &&
                                                            y.actual[0]
                                                              .status !=
                                                            'POSTED' &&
                                                            setDeadline()
                                                          " class="font-size-12 ms-1" :class="{
                                                            'text-danger':
                                                              setDeadline() <
                                                              new Date(),
                                                          }">Deadline:
                                                            {{
                                                              formatDateWithTime(
                                                                setDeadline()
                                                              )
                                                            }}</b>
                                                          <b v-else-if="
                                                            y.actual.length &&
                                                            y.actual[0]
                                                              .status ==
                                                            'RETURNED' &&
                                                            y.actual[0]
                                                              .returnExpiry
                                                          " class="font-size-12 ms-1" :class="new Date(
                                                            y.actual[0].returnExpiry
                                                          ) <= new Date()
                                                            ? 'text-danger'
                                                            : 'text-warning'
                                                            ">Deadline:
                                                            {{
                                                              formatDateWithTime(
                                                                new Date(
                                                                  y.actual[0].returnExpiry
                                                                )
                                                              )
                                                            }}</b>
                                                        </div>
                                                        <div>
                                                          <button v-if="
                                                            (y.actual
                                                              .length &&
                                                              y.actual[0]
                                                                .jsonRemarks !=
                                                              '' &&
                                                              y.actual[0]
                                                                .jsonRemarks !=
                                                              null) ||
                                                            y.targetLogs
                                                              .length > 0
                                                          " type="button" @click="
                                                            viewReturnRemarks(
                                                              y.actual
                                                                .length &&
                                                              y.actual[0]
                                                                .jsonRemarks,
                                                              y.targetLogs
                                                            )
                                                            " class="btn btn-sm btn-outline-secondary mb-2 me-2">
                                                            <i class="mdi mdi-format-list-numbered fs-6"></i>
                                                            View Logs
                                                          </button>
                                                          <!-- <button
                                                          type="button"
                                                          @click="
                                                            y.addDocu = true
                                                          "
                                                          class="btn btn-sm btn-outline-info mb-2 me-2"
                                                          :id="`target-document${y.id}`"
                                                        >
                                                          <i
                                                            class="mdi mdi-upload fs-6"
                                                          ></i>
                                                          Upload Documents
                                                        </button>
                                                        <upload-popover
                                                          :option="
                                                            uploadOptions
                                                          "
                                                          :sourceId="y.id"
                                                          @uploaded="
                                                            uploadedDocument(
                                                              $event,
                                                              y.id,
                                                              'Target'
                                                            )
                                                          "
                                                          :showPV="y.addDocu"
                                                          @closePopover="
                                                            y.addDocu = false
                                                          "
                                                          :dzId="`dropzone-target${y.id}`"
                                                          :pvId="`target-document${y.id}`"
                                                        ></upload-popover> -->
                                                          <button type="button" @click="
                                                            setMeasurement(y)
                                                            " class="btn btn-sm btn-primary mb-2 me-2">
                                                            <i class="mdi mdi-star text-warning fs-6"></i>
                                                            Performance Rubric
                                                          </button>
                                                          <button type="button" @click="
                                                            setActualValue(y)
                                                            " class="btn btn-sm btn-success mb-2">
                                                            <i class="mdi mdi-update fs-6"></i>
                                                            Actual
                                                            Accomplishments
                                                          </button>
                                                          <button v-if="
                                                            x.indicatorItemId ==
                                                            2451 &&
                                                            y.actual.length ==
                                                            0
                                                          " type="button" @click="
                                                            deleteInterveningTask(
                                                              y.id
                                                            )
                                                            " class="btn btn-sm btn-danger mb-2 ms-2">
                                                            <i class="mdi mdi-trash-can fs-6"></i>
                                                            Delete Target
                                                          </button>
                                                        </div>
                                                      </div>
                                                      <table class="table table-bordered border-primary mb-0">
                                                        <thead>
                                                          <tr>
                                                            <th class="text-center" style="
                                                                width: 120px;
                                                              ">
                                                              Quarter
                                                            </th>
                                                            <th class="text-center" style="
                                                                width: 120px;
                                                              ">
                                                              Target
                                                            </th>
                                                            <th class="text-center" style="
                                                                width: 120px;
                                                              ">
                                                              Actual
                                                            </th>
                                                            <th class="text-center">
                                                              Remarks
                                                            </th>
                                                            <th class="text-center" style="
                                                                width: 150px;
                                                              ">
                                                              Status
                                                            </th>
                                                          </tr>
                                                        </thead>
                                                        <tbody>
                                                          <tr v-for="x in 4" :key="x">
                                                            <td class="text-center align-middle">
                                                              Quarter {{ x }}
                                                            </td>
                                                            <td class="text-center">
                                                              {{ y.mainTarget.isPercentage ? `${y[`q${x}`]}%` : y[`q${x}`] }}
                                                            </td>
                                                            <td class="text-center" v-if="y.actual.length > 0">
                                                              {{ y.mainTarget.isPercentage ? `${y.actual[0][`q${x}`]}%` : y.actual[0][`q${x}`] }}
                                                            </td>
                                                            <td class="text-center" v-if="y.actual.length == 0"></td>
                                                            <td class="text-center">
                                                              {{ y.actual.length ? y.actual[0][`q${x}Remarks`] : "" }}
                                                            </td>
                                                            <td class="text-center">
                                                              <b :class="quarterClass(y, `q${x}`)">
                                                                {{ quarterDisplay(y, `q${x}`) }}
                                                              </b>
                                                            </td>
                                                          </tr>
                                                        </tbody>
                                                      </table>
                                                      <div v-if="
                                                        y.accomplishmentStatus ==
                                                        'SUBMITTED' ||
                                                        y.accomplishmentStatus ==
                                                        'COMPLETED'
                                                      ">
                                                        <div class="mt-3">
                                                          <label class="text-white">Validator's
                                                            Feedback:</label>
                                                          <div class="form-control">
                                                            {{
                                                              y.planningFeedback
                                                                ? validatorFeedback(
                                                                  y.planningFeedback
                                                                )
                                                                : "N/A"
                                                            }}
                                                          </div>
                                                        </div>
                                                        <div class="mt-3">
                                                          <label class="text-white">Validator's
                                                            Remarks:</label>
                                                          <div class="form-control" style="
                                                              min-height: 70px;
                                                            ">
                                                            {{
                                                              y.planningRemarks
                                                                ? y.planningRemarks
                                                                : "N/A"
                                                            }}
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div v-if="
                                                        y.accomplishmentStatus ==
                                                        'SUBMITTED' ||
                                                        y.accomplishmentStatus ==
                                                        'COMPLETED'
                                                      " class="mt-3">
                                                        <label class="text-white m-0">PMT Rating
                                                          <span v-if="
                                                            y.accomplishmentStatus ==
                                                            'SUBMITTED'
                                                          ">(DRAFT)</span>:</label>
                                                        <div v-if="
                                                          !y.isNotApplicable
                                                        " class="row">
                                                          <div class="col-4">
                                                            <label class="font-size-12 text-white"
                                                              for="scoreQuality">Effectiveness /
                                                              Quality</label>
                                                            <input id="scoreQuality" type="text" class="form-control"
                                                              v-model="y.evaluationScoreQuality
                                                                " disabled />
                                                          </div>
                                                          <div class="col-4">
                                                            <label class="font-size-12 text-white"
                                                              for="scoreEfficiency">Efficiency</label>
                                                            <input id="scoreEfficiency" type="text" class="form-control"
                                                              v-model="y.evaluationScoreEfficiency
                                                                " disabled />
                                                          </div>
                                                          <div class="col-4">
                                                            <label class="font-size-12 text-white"
                                                              for="scoreTimeliness">Timeliness</label>
                                                            <input id="scoreTimeliness" type="text" class="form-control"
                                                              v-model="y.evaluationScoreTimeliness
                                                                " disabled />
                                                          </div>
                                                        </div>
                                                        <div v-else class="form-control mt-2">
                                                          N/A
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </div>
                                              </div>
                                            </b-collapse>
                                            <hr />
                                          </li>
                                          <li>
                                            <div
                                              class="d-flex align-items-center justify-content-between cursor-pointer"
                                              @click="getAttachments(y)">
                                              <div>
                                                <h6 class="mb-0 text-warning">
                                                  <i class="bx bx-paperclip"></i>
                                                  Attachments
                                                </h6>
                                              </div>
                                              <h5 class="mb-0">
                                                <i class="bx bx-chevron-right rotate" :class="{
                                                  'rotate-90':
                                                    y.showAttachments,
                                                }"></i>
                                              </h5>
                                            </div>
                                            <b-collapse :visible="y.showAttachments"
                                              :accordion="`target-attachment-accordion-${type}-${y.id}`"
                                              role="tabpanel">
                                              <hr />
                                              <div class="row">
                                                <div class="col-md-2">
                                                  <input type="search" class="form-control"
                                                    placeholder="Search Attachments" v-model="y.fileSearch"
                                                    @input="searchDocu(y)" />
                                                </div>
                                              </div>
                                              <b-row class="mt-2">
                                                <b-col>
                                                  <h5
                                                    class="d-flex justify-content-center align-items-center ms-4 font-size-14"
                                                    v-if="y.attachmentLoading">
                                                    <div class="preloader-component me-2">
                                                      <div class="status">
                                                        <div class="spinner-chase w-20px h-20px">
                                                          <div class="chase-dot"></div>
                                                          <div class="chase-dot"></div>
                                                          <div class="chase-dot"></div>
                                                          <div class="chase-dot"></div>
                                                          <div class="chase-dot"></div>
                                                          <div class="chase-dot"></div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <strong>Loading...</strong>
                                                  </h5>
                                                  <div v-else-if="
                                                    searchDocu(y).length == 0
                                                  " class="d-flex align-items-center text-center">
                                                    <h6 v-if="y.fileSearch">
                                                      No document found.
                                                    </h6>
                                                    <h6 v-else>
                                                      Search not found.
                                                    </h6>
                                                  </div>
                                                  <div v-else>
                                                    <div class="row mb-3" v-if="
                                                      searchDocu(y, 'Target')
                                                        .length > 0
                                                    ">
                                                      <div class="col-md-12">
                                                        <b>Target Documents</b>
                                                      </div>
                                                      <div class="col-md-3" v-for="(
z, index
                                                        ) in searchDocu(
  y,
  'Target'
)" :key="z.id">
                                                        <div class="position-relative cursor-pointer border mt-2 br-5"
                                                          :style="`z-index: ${searchDocu(
                                                            y,
                                                            'Target'
                                                          ).length - index
                                                            }`">
                                                          <div class="border p-3">
                                                            <div>
                                                              <div class="float-end ms-2">
                                                                <b-dropdown id="dropdown-dropleft" right variant="link"
                                                                  toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                  menu-class="dropdown-menu-end" no-caret>
                                                                  <template #button-content>
                                                                    <i class="mdi mdi-dots-horizontal"></i>
                                                                  </template>
                                                                  <b-dropdown-item @click="
                                                                    openDocument(
                                                                      z
                                                                    )
                                                                    "><i
                                                                      class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                                                                  <b-dropdown-item variant="danger" @click="
                                                                    removeFile(
                                                                      z.id,
                                                                      y.id
                                                                    )
                                                                    "><i
                                                                      class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                                                                </b-dropdown>
                                                              </div>
                                                              <div class="avatar-xs me-3 mb-2" @click="
                                                                openDocument(
                                                                  z
                                                                )
                                                                ">
                                                                <div class="avatar-title bg-transparent rounded">
                                                                  <i v-if="
                                                                    z.fileType.includes(
                                                                      'image'
                                                                    )
                                                                  " class="mdi mdi-image font-size-24 text-purple"></i>
                                                                  <i v-if="
                                                                    z.fileType.includes(
                                                                      'application'
                                                                    )
                                                                  "
                                                                    class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                                                                </div>
                                                              </div>
                                                              <div class="d-flex" @click="
                                                                openDocument(
                                                                  z
                                                                )
                                                                ">
                                                                <div class="overflow-hidden me-auto">
                                                                  <h5 class="font-size-14 text-truncate mb-1">
                                                                    {{
                                                                      z.description
                                                                    }}
                                                                  </h5>
                                                                  <p class="text-muted mb-0">
                                                                    {{
                                                                      formatDateWithTime(
                                                                        new Date(
                                                                          z.dateTimeUploaded
                                                                        )
                                                                      )
                                                                    }}
                                                                  </p>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>

                                                    <div v-for="mov in y.mov" :key="mov.id" class="row mb-3">
                                                      <div v-if="
                                                        filterDocuByType(
                                                          searchDocu(y),
                                                          mov.mode,
                                                          mov.id
                                                        ).length > 0
                                                      " class="col-md-12 mb-1">
                                                        <b>{{ mov.mode }}</b>
                                                      </div>
                                                      <div v-if="
                                                        searchQuarterDocu(
                                                          y,
                                                          `Quarter 1 Files: ${mov.mode}`,
                                                          `Quarter 1 Files: ${mov.id}`
                                                        ).length > 0
                                                      " class="row">
                                                        <span class="font-size-14">Quarter 1 Files</span>
                                                        <div class="col-md-3" v-for="(
z, index
                                                          ) in searchQuarterDocu(
  y,
  `Quarter 1 Files: ${mov.mode}`,
  `Quarter 1 Files: ${mov.id}`
)" :key="z.id">
                                                          <div class="position-relative cursor-pointer border mt-2 br-5"
                                                            :style="`z-index: ${searchQuarterDocu(
                                                              y,
                                                              `Quarter 1 Files: ${mov.mode}`,
                                                              `Quarter 1 Files: ${mov.id}`
                                                            ).length - index
                                                              }`">
                                                            <div class="border p-3">
                                                              <div>
                                                                <div class="float-end ms-2">
                                                                  <b-dropdown id="dropdown-dropleft" right
                                                                    variant="link"
                                                                    toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                    menu-class="dropdown-menu-end" no-caret>
                                                                    <template #button-content>
                                                                      <i class="mdi mdi-dots-horizontal"></i>
                                                                    </template>
                                                                    <b-dropdown-item @click="
                                                                      openDocument(
                                                                        z
                                                                      )
                                                                      "><i
                                                                        class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                                                                    <b-dropdown-item variant="danger" @click="
                                                                      removeFile(
                                                                        z.id,
                                                                        y.id
                                                                      )
                                                                      "><i
                                                                        class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                                                                  </b-dropdown>
                                                                </div>
                                                                <div class="avatar-xs me-3 mb-2" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="avatar-title bg-transparent rounded">
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'image'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-image font-size-24 text-purple"></i>
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'application'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                                                                  </div>
                                                                </div>
                                                                <div class="d-flex" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="overflow-hidden me-auto">
                                                                    <h5 class="font-size-14 text-truncate mb-1">
                                                                      {{
                                                                        z.description
                                                                      }}
                                                                    </h5>
                                                                    <p class="text-muted mb-0">
                                                                      {{
                                                                        formatDateWithTime(
                                                                          new Date(
                                                                            z.dateTimeUploaded
                                                                          )
                                                                        )
                                                                      }}
                                                                    </p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div v-if="
                                                        searchQuarterDocu(
                                                          y,
                                                          `Quarter 2 Files: ${mov.mode}`,
                                                          `Quarter 2 Files: ${mov.id}`
                                                        ).length > 0
                                                      " class="row">
                                                        <span class="font-size-14">Quarter 2 Files</span>
                                                        <div class="col-md-3" v-for="(
z, index
                                                          ) in searchQuarterDocu(
  y,
  `Quarter 2 Files: ${mov.mode}`,
  `Quarter 2 Files: ${mov.id}`
)" :key="z.id">
                                                          <div class="position-relative cursor-pointer border mt-2 br-5"
                                                            :style="`z-index: ${searchQuarterDocu(
                                                              y,
                                                              `Quarter 2 Files: ${mov.mode}`,
                                                              `Quarter 2 Files: ${mov.id}`
                                                            ).length - index
                                                              }`">
                                                            <div class="border p-3">
                                                              <div>
                                                                <div class="float-end ms-2">
                                                                  <b-dropdown id="dropdown-dropleft" right
                                                                    variant="link"
                                                                    toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                    menu-class="dropdown-menu-end" no-caret>
                                                                    <template #button-content>
                                                                      <i class="mdi mdi-dots-horizontal"></i>
                                                                    </template>
                                                                    <b-dropdown-item @click="
                                                                      openDocument(
                                                                        z
                                                                      )
                                                                      "><i
                                                                        class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                                                                    <b-dropdown-item variant="danger" @click="
                                                                      removeFile(
                                                                        z.id,
                                                                        y.id
                                                                      )
                                                                      "><i
                                                                        class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                                                                  </b-dropdown>
                                                                </div>
                                                                <div class="avatar-xs me-3 mb-2" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="avatar-title bg-transparent rounded">
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'image'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-image font-size-24 text-purple"></i>
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'application'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                                                                  </div>
                                                                </div>
                                                                <div class="d-flex" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="overflow-hidden me-auto">
                                                                    <h5 class="font-size-14 text-truncate mb-1">
                                                                      {{
                                                                        z.description
                                                                      }}
                                                                    </h5>
                                                                    <p class="text-muted mb-0">
                                                                      {{
                                                                        formatDateWithTime(
                                                                          new Date(
                                                                            z.dateTimeUploaded
                                                                          )
                                                                        )
                                                                      }}
                                                                    </p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div v-if="
                                                        searchQuarterDocu(
                                                          y,
                                                          `Quarter 3 Files: ${mov.mode}`,
                                                          `Quarter 3 Files: ${mov.id}`
                                                        ).length > 0
                                                      " class="row">
                                                        <span class="font-size-14">Quarter 3 Files</span>
                                                        <div class="col-md-3" v-for="(
z, index
                                                          ) in searchQuarterDocu(
  y,
  `Quarter 3 Files: ${mov.mode}`,
  `Quarter 3 Files: ${mov.id}`
)" :key="z.id">
                                                          <div class="position-relative cursor-pointer border mt-2 br-5"
                                                            :style="`z-index: ${searchQuarterDocu(
                                                              y,
                                                              `Quarter 3 Files: ${mov.mode}`,
                                                              `Quarter 3 Files: ${mov.id}`
                                                            ).length - index
                                                              }`">
                                                            <div class="border p-3">
                                                              <div>
                                                                <div class="float-end ms-2">
                                                                  <b-dropdown id="dropdown-dropleft" right
                                                                    variant="link"
                                                                    toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                    menu-class="dropdown-menu-end" no-caret>
                                                                    <template #button-content>
                                                                      <i class="mdi mdi-dots-horizontal"></i>
                                                                    </template>
                                                                    <b-dropdown-item @click="
                                                                      openDocument(
                                                                        z
                                                                      )
                                                                      "><i
                                                                        class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                                                                    <b-dropdown-item variant="danger" @click="
                                                                      removeFile(
                                                                        z.id,
                                                                        y.id
                                                                      )
                                                                      "><i
                                                                        class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                                                                  </b-dropdown>
                                                                </div>
                                                                <div class="avatar-xs me-3 mb-2" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="avatar-title bg-transparent rounded">
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'image'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-image font-size-24 text-purple"></i>
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'application'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                                                                  </div>
                                                                </div>
                                                                <div class="d-flex" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="overflow-hidden me-auto">
                                                                    <h5 class="font-size-14 text-truncate mb-1">
                                                                      {{
                                                                        z.description
                                                                      }}
                                                                    </h5>
                                                                    <p class="text-muted mb-0">
                                                                      {{
                                                                        formatDateWithTime(
                                                                          new Date(
                                                                            z.dateTimeUploaded
                                                                          )
                                                                        )
                                                                      }}
                                                                    </p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                      <div v-if="
                                                        searchQuarterDocu(
                                                          y,
                                                          `Quarter 4 Files: ${mov.mode}`,
                                                          `Quarter 4 Files: ${mov.id}`
                                                        ).length > 0
                                                      " class="row">
                                                        <span class="font-size-14">Quarter 4 Files</span>
                                                        <div class="col-md-3" v-for="(
z, index
                                                          ) in searchQuarterDocu(
  y,
  `Quarter 4 Files: ${mov.mode}`,
  `Quarter 4 Files: ${mov.id}`
)" :key="z.id">
                                                          <div class="position-relative cursor-pointer border mt-2 br-5"
                                                            :style="`z-index: ${searchQuarterDocu(
                                                              y,
                                                              `Quarter 4 Files: ${mov.mode}`,
                                                              `Quarter 4 Files: ${mov.id}`
                                                            ).length - index
                                                              }`">
                                                            <div class="border p-3">
                                                              <div>
                                                                <div class="float-end ms-2">
                                                                  <b-dropdown id="dropdown-dropleft" right
                                                                    variant="link"
                                                                    toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                    menu-class="dropdown-menu-end" no-caret>
                                                                    <template #button-content>
                                                                      <i class="mdi mdi-dots-horizontal"></i>
                                                                    </template>
                                                                    <b-dropdown-item @click="
                                                                      openDocument(
                                                                        z
                                                                      )
                                                                      "><i
                                                                        class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                                                                    <b-dropdown-item variant="danger" @click="
                                                                      removeFile(
                                                                        z.id,
                                                                        y.id
                                                                      )
                                                                      "><i
                                                                        class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                                                                  </b-dropdown>
                                                                </div>
                                                                <div class="avatar-xs me-3 mb-2" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="avatar-title bg-transparent rounded">
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'image'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-image font-size-24 text-purple"></i>
                                                                    <i v-if="
                                                                      z.fileType.includes(
                                                                        'application'
                                                                      )
                                                                    "
                                                                      class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                                                                  </div>
                                                                </div>
                                                                <div class="d-flex" @click="
                                                                  openDocument(
                                                                    z
                                                                  )
                                                                  ">
                                                                  <div class="overflow-hidden me-auto">
                                                                    <h5 class="font-size-14 text-truncate mb-1">
                                                                      {{
                                                                        z.description
                                                                      }}
                                                                    </h5>
                                                                    <p class="text-muted mb-0">
                                                                      {{
                                                                        formatDateWithTime(
                                                                          new Date(
                                                                            z.dateTimeUploaded
                                                                          )
                                                                        )
                                                                      }}
                                                                    </p>
                                                                  </div>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                    <div class="row mb-3" v-if="
                                                      searchDocu(
                                                        y,
                                                        'Catchup Plan Attachment'
                                                      ).length > 0
                                                    ">
                                                      <div class="col-md-12">
                                                        <b>Catchup Plan /
                                                          Justification
                                                          Documents</b>
                                                      </div>
                                                      <div class="col-md-3" v-for="(
z, index
                                                        ) in searchDocu(
  y,
  'Catchup Plan Attachment'
)" :key="z.id">
                                                        <div class="position-relative cursor-pointer border mt-2 br-5"
                                                          :style="`z-index: ${searchDocu(
                                                            y,
                                                            'Catchup Plan Attachment'
                                                          ).length - index
                                                            }`">
                                                          <div class="border p-3">
                                                            <div>
                                                              <div class="float-end ms-2">
                                                                <b-dropdown id="dropdown-dropleft" right variant="link"
                                                                  toggle-class="text-decoration-none text-dark font-size-16 pt-0"
                                                                  menu-class="dropdown-menu-end" no-caret>
                                                                  <template #button-content>
                                                                    <i class="mdi mdi-dots-horizontal"></i>
                                                                  </template>
                                                                  <b-dropdown-item @click="
                                                                    openDocument(
                                                                      z
                                                                    )
                                                                    "><i
                                                                      class="bx bx-link-external me-1"></i>Open</b-dropdown-item>
                                                                  <b-dropdown-item variant="danger" @click="
                                                                    removeFile(
                                                                      z.id,
                                                                      y.id
                                                                    )
                                                                    "><i
                                                                      class="bx bx-trash me-1"></i>Remove</b-dropdown-item>
                                                                </b-dropdown>
                                                              </div>
                                                              <div class="avatar-xs me-3 mb-2" @click="
                                                                openDocument(
                                                                  z
                                                                )
                                                                ">
                                                                <div class="avatar-title bg-transparent rounded">
                                                                  <i v-if="
                                                                    z.fileType.includes(
                                                                      'image'
                                                                    )
                                                                  " class="mdi mdi-image font-size-24 text-purple"></i>
                                                                  <i v-if="
                                                                    z.fileType.includes(
                                                                      'application'
                                                                    )
                                                                  "
                                                                    class="mdi mdi-file-pdf-outline font-size-24 text-danger"></i>
                                                                </div>
                                                              </div>
                                                              <div class="d-flex" @click="
                                                                openDocument(
                                                                  z
                                                                )
                                                                ">
                                                                <div class="overflow-hidden me-auto">
                                                                  <h5 class="font-size-14 text-truncate mb-1">
                                                                    {{
                                                                      z.description
                                                                    }}
                                                                  </h5>
                                                                  <p class="text-muted mb-0">
                                                                    {{
                                                                      formatDateWithTime(
                                                                        new Date(
                                                                          z.dateTimeUploaded
                                                                        )
                                                                      )
                                                                    }}
                                                                  </p>
                                                                </div>
                                                              </div>
                                                            </div>
                                                          </div>
                                                        </div>
                                                      </div>
                                                    </div>
                                                  </div>
                                                </b-col>
                                              </b-row>
                                            </b-collapse>
                                            <hr />
                                          </li>
                                        </ul>
                                      </b-card-body>
                                    </b-collapse>
                                  </b-card>
                                </div>
                              </b-card-body>
                            </b-collapse>
                          </b-card>
                        </div>
                        <div class="row">
                          <div class="col">
                            <div class="dataTables_paginate paging_simple_numbers float-end">
                              <ul class="pagination pagination-rounded mb-0">
                                <!-- pagination -->
                                <b-pagination v-model="currentPage" :total-rows="rows"
                                  :per-page="perPage"></b-pagination>
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </div>
      </b-tabs>
    </div>
    <RatingScale ref="RatingScale" @saveRatingStatus="saveRatingStatus($event)"></RatingScale>
    <print-options ref="printOpt"></print-options>
    <attachment-modal :wActions="attWActions" :title="uploadTitle" ref="attachmentModal"></attachment-modal>
  </Layout>
</template>
